export const CRUD_TEMPLATE = {
  "dsl":
    {
      "widgetName": "MainContainer",
      "backgroundColor": "none",
      "rightColumn": 1224,
      "snapColumns": 64,
      "detachFromLayout": true,
      "widgetId": "0",
      "topRow": 0,
      "bottomRow": 920,
      "containerStyle": "none",
      "snapRows": 69,
      "parentRowSpace": 1,
      "type": "CANVAS_WIDGET",
      "canExtend": true,
      "version": 82,
      "minHeight": 710,
      "parentColumnSpace": 1,
      "dynamicBindingPathList": [],
      "leftColumn": 0,
      "children": [
        {
          "isVisible": true,
          "backgroundColor": "#FFFFFF",
          "widgetName": "Container1",
          "containerStyle": "card",
          "borderColor": "#E0DEDE",
          "borderWidth": "0",
          "boxShadow": "none",
          "animateLoading": true,
          "children": [
            {
              "isVisible": true,
              "widgetName": "Canvas2",
              "version": 1,
              "detachFromLayout": true,
              "flexLayers": [],
              "responsiveBehavior": "fill",
              "minWidth": 450,
              "type": "CANVAS_WIDGET",
              "hideCard": true,
              "isDeprecated": false,
              "displayName": "Canvas",
              "key": "ymn28jtkbi",
              "containerStyle": "none",
              "canExtend": false,
              "children": [
                {
                  "isVisible": true,
                  "animateLoading": true,
                  "text": "新增",
                  "buttonVariant": "PRIMARY",
                  "placement": "CENTER",
                  "widgetName": "Button3",
                  "isDisabled": false,
                  "isDefaultClickDisabled": true,
                  "disabledWhenInvalid": false,
                  "resetFormOnClick": false,
                  "recaptchaType": "V3",
                  "version": 1,
                  "borderRadius": "0.375rem",
                  "responsiveBehavior": "hug",
                  "minWidth": 120,
                  "searchTags": [
                    "click",
                    "submit"
                  ],
                  "type": "BUTTON_WIDGET",
                  "hideCard": false,
                  "isDeprecated": false,
                  "displayName": "Button",
                  "key": "9qcv6rozpb",
                  "iconSVG": "./static/media/icon.2075e59f4c855dc62f664870206244a0.svg",
                  "widgetId": "pvtsuf9mrt",
                  "renderMode": "CANVAS",
                  "buttonColor": "{{appsmith.theme.colors.primaryColor}}",
                  "boxShadow": "none",
                  "isLoading": false,
                  "parentColumnSpace": 13.95703125,
                  "parentRowSpace": 10,
                  "leftColumn": 1,
                  "rightColumn": 7,
                  "topRow": 2,
                  "bottomRow": 5,
                  "mobileLeftColumn": 0,
                  "mobileRightColumn": 8,
                  "mobileTopRow": 0,
                  "mobileBottomRow": 4,
                  "parentId": "mqdcabmfub",
                  "dynamicBindingPathList": [
                    {
                      "key": "buttonColor"
                    }
                  ],
                  "dynamicTriggerPathList": [],
                  "onClick": {
                    "name": "onClick",
                    "status": "add",
                    "label": "触发事件",
                    "children": [
                      {
                        "name": "block",
                        "type": "block",
                        "uid": "5bbda8337d934e64acac4a5452f6d134",
                        "children": [
                          {
                            "name": "action",
                            "type": "action",
                            "uid": "45d49b06f0204470aa86a895a9bb939b",
                            "pid": "5bbda8337d934e64acac4a5452f6d134",
                            "actionConfig": {
                              "action": "showModal",
                              "actionId": 178899498242577,
                              "modalName": "add_Modal",
                              "apiTarget": "pvtsuf9mrt"
                            }
                          },
                          {
                            "name": "success",
                            "type": "success",
                            "uid": "7c90d255024947af8e11981732f00298",
                            "pid": "5bbda8337d934e64acac4a5452f6d134"
                          },
                          {
                            "name": "fail",
                            "type": "fail",
                            "uid": "accaf849e5294e8fa7e11a0f3483a419",
                            "pid": "5bbda8337d934e64acac4a5452f6d134"
                          }
                        ]
                      }
                    ]
                  },
                  "iconName": "AddOne",
                  "iconAlign": "left"
                },
                {
                  "isVisible": true,
                  "animateLoading": true,
                  "text": "导入",
                  "buttonVariant": "PRIMARY",
                  "placement": "CENTER",
                  "widgetName": "Button10",
                  "isDisabled": false,
                  "isDefaultClickDisabled": true,
                  "disabledWhenInvalid": false,
                  "resetFormOnClick": false,
                  "recaptchaType": "V3",
                  "version": 1,
                  "borderRadius": "0.375rem",
                  "responsiveBehavior": "hug",
                  "minWidth": 120,
                  "searchTags": [
                    "click",
                    "submit"
                  ],
                  "type": "BUTTON_WIDGET",
                  "hideCard": false,
                  "isDeprecated": false,
                  "displayName": "Button",
                  "key": "9qcv6rozpb",
                  "iconSVG": "./static/media/icon.2075e59f4c855dc62f664870206244a0.svg",
                  "widgetId": "o8hzzixx3w",
                  "renderMode": "CANVAS",
                  "buttonColor": "#f4f4f5",
                  "boxShadow": "none",
                  "isLoading": false,
                  "parentColumnSpace": 13.95703125,
                  "parentRowSpace": 10,
                  "leftColumn": 8,
                  "rightColumn": 14,
                  "topRow": 2,
                  "bottomRow": 5,
                  "mobileLeftColumn": 5,
                  "mobileRightColumn": 21,
                  "mobileTopRow": 1,
                  "mobileBottomRow": 5,
                  "parentId": "mqdcabmfub",
                  "dynamicBindingPathList": [],
                  "dynamicTriggerPathList": [],
                  "onClick": {
                    "label": "触发事件",
                    "name": "onClick",
                    "status": "add",
                    "children": [
                      {
                        "name": "block",
                        "type": "block",
                        "uid": "b714c7772dbf427a9c73802d2d24652f",
                        "children": [
                          {
                            "name": "action",
                            "type": "action",
                            "pid": "b714c7772dbf427a9c73802d2d24652f",
                            "uid": "1a16096c369649f8be1e39e5be20181c",
                            "actionConfig": {
                              "action": "imported",
                              "actionId": 412744702667833,
                              "apiTarget": "o8hzzixx3w",
                              "apiDescription": "导入数据",
                              "linkageId": null,
                              "linkageEvent": null,
                              "modalName": null
                            },
                            "children": null
                          },
                          {
                            "name": "success",
                            "type": "success",
                            "pid": "b714c7772dbf427a9c73802d2d24652f",
                            "uid": "0f1bbc648afa469fbbf76f111be355a0",
                            "actionConfig": null,
                            "children": [
                              {
                                "name": "block",
                                "type": "block",
                                "uid": "d42c505d9d9a4f3b8a9eaa76546c9fba",
                                "children": [
                                  {
                                    "name": "action",
                                    "type": "action",
                                    "pid": "d42c505d9d9a4f3b8a9eaa76546c9fba",
                                    "uid": "d6312170b0164970bd770613d824c04e",
                                    "actionConfig": {
                                      "action": "linkage",
                                      "actionId": 412744702667833,
                                      "apiTarget": "o8hzzixx3w",
                                      "apiDescription": null,
                                      "linkageId": "ph6z3iu55h",
                                      "linkageEvent": "onLoad",
                                      "modalName": null
                                    },
                                    "children": null
                                  },
                                  {
                                    "name": "success",
                                    "type": "success",
                                    "pid": "d42c505d9d9a4f3b8a9eaa76546c9fba",
                                    "uid": "9d66557483f44718b23edebdda8b75e0",
                                    "actionConfig": null,
                                    "children": null
                                  },
                                  {
                                    "name": "fail",
                                    "type": "fail",
                                    "pid": "d42c505d9d9a4f3b8a9eaa76546c9fba",
                                    "uid": "e65d395318c84264a9b35874b3797c52",
                                    "actionConfig": null,
                                    "children": null
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "name": "fail",
                            "type": "fail",
                            "pid": "b714c7772dbf427a9c73802d2d24652f",
                            "uid": "2fb9edd1f0dc49838f7c8c5f2e5a163e",
                            "actionConfig": null,
                            "children": null
                          }
                        ]
                      }
                    ]
                  },
                  "iconName": "DownTwo",
                  "iconAlign": "left"
                },
                {
                  "isVisible": true,
                  "animateLoading": true,
                  "text": "导出",
                  "buttonVariant": "PRIMARY",
                  "placement": "CENTER",
                  "widgetName": "Button10Copy",
                  "isDisabled": false,
                  "isDefaultClickDisabled": true,
                  "disabledWhenInvalid": false,
                  "resetFormOnClick": false,
                  "recaptchaType": "V3",
                  "version": 1,
                  "borderRadius": "0.375rem",
                  "responsiveBehavior": "hug",
                  "minWidth": 120,
                  "searchTags": [
                    "click",
                    "submit"
                  ],
                  "type": "BUTTON_WIDGET",
                  "hideCard": false,
                  "isDeprecated": false,
                  "displayName": "Button",
                  "key": "9qcv6rozpb",
                  "iconSVG": "./static/media/icon.2075e59f4c855dc62f664870206244a0.svg",
                  "widgetId": "podwypxg6q",
                  "renderMode": "CANVAS",
                  "buttonColor": "#f4f4f5",
                  "boxShadow": "none",
                  "isLoading": false,
                  "parentColumnSpace": 13.95703125,
                  "parentRowSpace": 10,
                  "leftColumn": 15,
                  "rightColumn": 21,
                  "topRow": 2,
                  "bottomRow": 5,
                  "mobileLeftColumn": 5,
                  "mobileRightColumn": 21,
                  "mobileTopRow": 1,
                  "mobileBottomRow": 5,
                  "parentId": "mqdcabmfub",
                  "dynamicBindingPathList": [],
                  "dynamicTriggerPathList": [],
                  "onClick": {
                    "label": "触发事件",
                    "name": "onClick",
                    "status": "add",
                    "children": [
                      {
                        "name": "block",
                        "type": "block",
                        "uid": "937e4143d4b647eebe15ded90ed3b3b6",
                        "children": [
                          {
                            "name": "action",
                            "type": "action",
                            "pid": "937e4143d4b647eebe15ded90ed3b3b6",
                            "uid": "faf3c1a1172f4fa3a3a0ad63cf642538",
                            "actionConfig": {
                              "action": "exported",
                              "actionId": 412744702667819,
                              "apiTarget": "podwypxg6q",
                              "apiDescription": "导出数据",
                              "linkageId": null,
                              "linkageEvent": null,
                              "modalName": null
                            },
                            "children": null
                          },
                          {
                            "name": "success",
                            "type": "success",
                            "pid": "937e4143d4b647eebe15ded90ed3b3b6",
                            "uid": "54d7c658f24c4fcf9acf5b4d39454cfe",
                            "actionConfig": null,
                            "children": null
                          },
                          {
                            "name": "fail",
                            "type": "fail",
                            "pid": "937e4143d4b647eebe15ded90ed3b3b6",
                            "uid": "4eaa85d6e74f4b89991b1326adaf02c1",
                            "actionConfig": null,
                            "children": null
                          }
                        ]
                      }
                    ]
                  },
                  "iconName": "UpTwo",
                  "iconAlign": "left"
                },
                {
                  "isVisible": true,
                  "animateLoading": true,
                  "text": "批量删除",
                  "buttonVariant": "PRIMARY",
                  "placement": "CENTER",
                  "widgetName": "Button10CopyCopy1",
                  "isDisabled": false,
                  "isDefaultClickDisabled": true,
                  "disabledWhenInvalid": false,
                  "resetFormOnClick": false,
                  "recaptchaType": "V3",
                  "version": 1,
                  "borderRadius": "0.375rem",
                  "responsiveBehavior": "hug",
                  "minWidth": 120,
                  "searchTags": [
                    "click",
                    "submit"
                  ],
                  "type": "BUTTON_WIDGET",
                  "hideCard": false,
                  "isDeprecated": false,
                  "displayName": "Button",
                  "key": "9qcv6rozpb",
                  "iconSVG": "./static/media/icon.2075e59f4c855dc62f664870206244a0.svg",
                  "widgetId": "14594a54tf",
                  "renderMode": "CANVAS",
                  "buttonColor": "#f4f4f5",
                  "boxShadow": "none",
                  "isLoading": false,
                  "parentColumnSpace": 13.95703125,
                  "parentRowSpace": 10,
                  "leftColumn": 22,
                  "rightColumn": 30,
                  "topRow": 2,
                  "bottomRow": 5,
                  "mobileLeftColumn": 5,
                  "mobileRightColumn": 21,
                  "mobileTopRow": 1,
                  "mobileBottomRow": 5,
                  "parentId": "mqdcabmfub",
                  "dynamicBindingPathList": [],
                  "dynamicTriggerPathList": [],
                  "iconName": "Delete",
                  "iconAlign": "left",
                  "onClick": {
                    "name": "onClick",
                    "status": "add",
                    "label": "触发事件",
                    "children": [
                      {
                        "name": "block",
                        "type": "block",
                        "uid": "8bbff3ecff954612a8430f65cacf1acb",
                        "children": [
                          {
                            "name": "if",
                            "type": "if",
                            "uid": "2883d48ec34e49cb95aedac55f6d2f33",
                            "pid": "8bbff3ecff954612a8430f65cacf1acb",
                            "values": {
                              "form_687": [
                                {
                                  "a": [
                                    "AntdTable1",
                                    "AntdTable1.currentItem.id"
                                  ],
                                  "b": "9"
                                }
                              ]
                            },
                            "children": [
                              {
                                "name": "block",
                                "type": "block",
                                "uid": "cbd9c88912734c56a070c6eea72a28c3",
                                "children": [
                                  {
                                    "name": "action",
                                    "type": "action",
                                    "uid": "1e1a266aa7bb45f7bd556fcd0fb2bfd1",
                                    "pid": "cbd9c88912734c56a070c6eea72a28c3",
                                    "actionConfig": {
                                      "action": "showModal",
                                      "actionId": 328053708576879,
                                      "modalName": "muldelete_Modal",
                                      "apiTarget": "14594a54tf"
                                    }
                                  },
                                  {
                                    "name": "success",
                                    "type": "success",
                                    "uid": "e778df87386f4879b42c9c203a10cf35",
                                    "pid": "cbd9c88912734c56a070c6eea72a28c3"
                                  },
                                  {
                                    "name": "fail",
                                    "type": "fail",
                                    "uid": "ef391422484949e5b9484aa8b38e4c66",
                                    "pid": "cbd9c88912734c56a070c6eea72a28c3"
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "name": "else",
                            "type": "else",
                            "uid": "905e2bc81c764a59839e88aebd13c9c4",
                            "pid": "8bbff3ecff954612a8430f65cacf1acb",
                            "children": [
                              {
                                "name": "block",
                                "type": "block",
                                "uid": "86c4830c9d444738b0ce1323d973f0e4",
                                "children": [
                                  {
                                    "name": "action",
                                    "type": "action",
                                    "uid": "4c343b9d7a1b4e889c87e740e1325b35",
                                    "pid": "86c4830c9d444738b0ce1323d973f0e4",
                                    "actionConfig": {
                                      "action": "showAlert",
                                      "actionId": 328053708576880,
                                      "message": "请先勾选需要删除的数据",
                                      "type": "info",
                                      "apiTarget": "14594a54tf"
                                    }
                                  },
                                  {
                                    "name": "success",
                                    "type": "success",
                                    "uid": "74776a079a444cf983e911db2c20bb7b",
                                    "pid": "86c4830c9d444738b0ce1323d973f0e4"
                                  },
                                  {
                                    "name": "fail",
                                    "type": "fail",
                                    "uid": "ceb80635a9324205aa34d0c40a80fe52",
                                    "pid": "86c4830c9d444738b0ce1323d973f0e4"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                },
                {
                  "isVisible": true,
                  "widgetName": "AntdTable1",
                  "isShowNo": true,
                  "label": "",
                  "currPage": 1,
                  "pageSize": 10,
                  "total": 10,
                  "selectedRowKeys": [],
                  "selectedRows": [],
                  "clickRow": {},
                  "pageSizeOptions": "10,20,50",
                  "isPagination": true,
                  "selectType": "checkbox",
                  "isRowSelection": false,
                  "actionCollapseIconColor": "#000",
                  "actionCollapseIcon": "more",
                  "tableActionNo": 3,
                  "isActionCollapse": false,
                  "isActionVisible": true,
                  "variant": "DEFAULT",
                  "compactMode": "middle",
                  "tableAction": {
                    "edit": {
                      "id": "edit",
                      "index": 0,
                      "label": "编辑",
                      "columnType": "button",
                      "isCellVisible": true,
                      "isCellDisable": false,
                      "btnType": "text",
                      "boxShadowBtn": "none",
                      "borderRadiusBtn": "2",
                      "btnIcon": "Edit",
                      "btnPosition": "left",
                      "btnTextAlign": "center",
                      "columnReg": "$data",
                      "onClick": {
                        "name": "tableAction.edit.onClick",
                        "status": "add",
                        "label": "触发事件",
                        "children": [
                          {
                            "name": "block",
                            "type": "block",
                            "uid": "37839a0b3e5741e785621b22baff9dbe",
                            "children": [
                              {
                                "name": "action",
                                "type": "action",
                                "uid": "8bb67e8129f844bd9ac0f4be6d7d2a16",
                                "pid": "37839a0b3e5741e785621b22baff9dbe",
                                "actionConfig": {
                                  "action": "showModal",
                                  "actionId": 328053700189659,
                                  "modalName": "edit_Modal",
                                  "apiTarget": "ph6z3iu55h"
                                }
                              },
                              {
                                "name": "success",
                                "type": "success",
                                "uid": "f1782a654b0a482dae3bbcf1b20752fd",
                                "pid": "37839a0b3e5741e785621b22baff9dbe"
                              },
                              {
                                "name": "fail",
                                "type": "fail",
                                "uid": "c02fb16b33c949288911c82e8f6d49b9",
                                "pid": "37839a0b3e5741e785621b22baff9dbe"
                              }
                            ]
                          }
                        ]
                      },
                      "editedStyleSelect": "default",
                      "conditionalStyle": {
                        "default": {
                          "style": {
                            "btnType": "default",
                            "boxShadowBtn": "none",
                            "borderRadiusBtn": "2",
                            "btnIcon": "none",
                            "btnPosition": "left",
                            "btnTextAlign": "center"
                          },
                          "label": "默认样式",
                          "value": "default"
                        }
                      }
                    },
                    "delete": {
                      "id": "delete",
                      "index": 1,
                      "label": "删除",
                      "columnType": "button",
                      "isCellVisible": true,
                      "isCellDisable": false,
                      "btnType": "text",
                      "boxShadowBtn": "none",
                      "borderRadiusBtn": "2",
                      "btnIcon": "DeleteFour",
                      "btnPosition": "left",
                      "btnTextAlign": "center",
                      "columnReg": "$data",
                      "backgroundBtn": "#52525b",
                      "fontColor": "#3f3f46",
                      "onClick": {
                        "name": "tableAction.delete.onClick",
                        "status": "add",
                        "label": "触发事件",
                        "children": [
                          {
                            "name": "block",
                            "type": "block",
                            "uid": "4ea2f31201d94184a634a112017ed991",
                            "children": [
                              {
                                "name": "action",
                                "type": "action",
                                "uid": "6da28c9f094048daa73ca3303e735c80",
                                "pid": "4ea2f31201d94184a634a112017ed991",
                                "actionConfig": {
                                  "action": "showModal",
                                  "actionId": 328053700189769,
                                  "modalName": "delete_Modal",
                                  "apiTarget": "ph6z3iu55h"
                                }
                              },
                              {
                                "name": "success",
                                "type": "success",
                                "uid": "6e5721cb3f5f4ce6a4659a1c0916060d",
                                "pid": "4ea2f31201d94184a634a112017ed991"
                              },
                              {
                                "name": "fail",
                                "type": "fail",
                                "uid": "5dfa7371a20145fd90887d3af51c6181",
                                "pid": "4ea2f31201d94184a634a112017ed991"
                              }
                            ]
                          }
                        ]
                      },
                      "editedStyleSelect": "default",
                      "conditionalStyle": {
                        "default": {
                          "style": {
                            "btnType": "default",
                            "boxShadowBtn": "none",
                            "borderRadiusBtn": "2",
                            "btnIcon": "none",
                            "btnPosition": "left",
                            "btnTextAlign": "center"
                          },
                          "label": "默认样式",
                          "value": "default"
                        }
                      }
                    }
                  },
                  "mappingConfig": {
                    "currPage": {
                      "id": "currPage",
                      "index": 0,
                      "label": "页码",
                      "type": "text"
                    },
                    "pageSize": {
                      "id": "pageSize",
                      "index": 1,
                      "label": "每页记录数",
                      "type": "text"
                    },
                    "selectId": {
                      "id": "selectId",
                      "index": 2,
                      "label": "单选Id",
                      "type": "text"
                    },
                    "selectIds": {
                      "id": "selectIds",
                      "index": 3,
                      "label": "多选Ids",
                      "type": "text"
                    }
                  },
                  "columnWidthMap": {
                    "_xh": 48,
                    "_cz": 167,
                    "bool": 120,
                    "dateTime": 120,
                    "dict": 120,
                    "email": 120,
                    "file": 120,
                    "float": 120,
                    "image": 120,
                    "int": 120,
                    "lineText": 120,
                    "longInt": 120,
                    "moreLineText": 120,
                    "richText": 120,
                    "creator": 120,
                    "createDate": 120,
                    "updater": 120,
                    "updateDate": 120
                  },
                  "fixTableColumns": {
                    "_xh": {
                      "id": "_xh",
                      "index": 0,
                      "label": "序号",
                      "columnType": "text"
                    },
                    "_cz": {
                      "id": "_cz",
                      "index": 1,
                      "label": "操作",
                      "columnType": "text"
                    }
                  },
                  "tableColumns": {
                  },
                  "mockData": [
                    {
                      "id": "1",
                      "name": "胡彦斌",
                      "age": 32,
                      "address": "西湖区湖底公园1号"
                    },
                    {
                      "id": "2",
                      "name": "胡彦祖",
                      "age": 42,
                      "address": "西湖区湖底公园1号"
                    }
                  ],
                  "tableData": [],
                  "textSizeBody": "0.875rem",
                  "textSizeHead": "0.875rem",
                  "horizontalAlignmentBody": "left",
                  "horizontalAlignmentHead": "left",
                  "verticalAlignmentBody": "center",
                  "verticalAlignmentHead": "center",
                  "borderWidth": "1",
                  "version": 1,
                  "type": "TABLE_WIDGET_ANTD",
                  "hideCard": false,
                  "isDeprecated": false,
                  "displayName": "AntdTable",
                  "key": "278rl3s3g3",
                  "iconSVG": "./static/media/icon.24905525921dd6f5ff46d0dd843b9e12.svg",
                  "needsHeightForContent": true,
                  "widgetId": "ph6z3iu55h",
                  "renderMode": "CANVAS",
                  "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                  "boxShadow": "{{appsmith.theme.boxShadow.appBoxShadow}}",
                  "accentColor": "{{appsmith.theme.colors.primaryColor}}",
                  "isLoading": false,
                  "parentColumnSpace": 8.382568359375,
                  "parentRowSpace": 10,
                  "leftColumn": 1,
                  "rightColumn": 127,
                  "topRow": 6,
                  "bottomRow": 74,
                  "mobileLeftColumn": 0,
                  "mobileRightColumn": 74,
                  "mobileTopRow": 7,
                  "mobileBottomRow": 35,
                  "parentId": "mqdcabmfub",
                  "dynamicBindingPathList": [
                    {
                      "key": "borderRadius"
                    },
                    {
                      "key": "boxShadow"
                    },
                    {
                      "key": "accentColor"
                    }
                  ],
                  "dynamicTriggerPathList": [],
                  "fontStyleHead": "bold",
                  "columnStyleKeys": [
                    "textSize",
                    "fontStyle",
                    "horizontalAlignment",
                    "verticalAlignment",
                    "btnType",
                    "backgroundBtn",
                    "fontColor",
                    "borderRadiusBtn",
                    "boxShadowBtn",
                    "imgSize",
                    "textColor",
                    "switchColor",
                    "btnIcon",
                    "btnPosition",
                    "btnTextAlign",
                    "fontFamily",
                    "textBgColor",
                    "cellBgColor",
                    "btnColor",
                    "iconColor",
                    "textBorderColor",
                    "textBorderWidth",
                    "textBorderRadius",
                    "textBorderBoxShadow",
                  ]
                }
              ],
              "minHeight": 100,
              "widgetId": "mqdcabmfub",
              "renderMode": "CANVAS",
              "isLoading": false,
              "parentColumnSpace": 1,
              "parentRowSpace": 1,
              "leftColumn": 0,
              "rightColumn": 245.875,
              "topRow": 0,
              "bottomRow": 760,
              "mobileLeftColumn": 0,
              "mobileRightColumn": 245.875,
              "mobileTopRow": 0,
              "mobileBottomRow": 100,
              "parentId": "xmx0hzp9xb",
              "dynamicBindingPathList": []
            }
          ],
          "objectFit": "cover",
          "version": 1,
          "flexVerticalAlignment": "start",
          "responsiveBehavior": "fill",
          "minWidth": 450,
          "minDynamicHeight": 10,
          "maxDynamicHeight": 9000,
          "dynamicHeight": "AUTO_HEIGHT",
          "shouldScrollContents": true,
          "searchTags": [
            "div",
            "parent",
            "group"
          ],
          "type": "CONTAINER_WIDGET",
          "hideCard": false,
          "isDeprecated": false,
          "displayName": "Container",
          "key": "m52qgy7k1z",
          "iconSVG": "./static/media/icon.c47c069fe28eb6d2d27f0fffdc053074.svg",
          "isCanvas": true,
          "widgetId": "xmx0hzp9xb",
          "renderMode": "CANVAS",
          "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
          "isLoading": false,
          "parentColumnSpace": 17.5625,
          "parentRowSpace": 10,
          "leftColumn": 1,
          "rightColumn": 127,
          "topRow": 16,
          "bottomRow": 92,
          "mobileLeftColumn": 0,
          "mobileRightColumn": 14,
          "mobileTopRow": 12,
          "mobileBottomRow": 22,
          "parentId": "0",
          "dynamicBindingPathList": [
            {
              "key": "borderRadius"
            }
          ],
          "dynamicTriggerPathList": [],
          "originalBottomRow": 94,
          "originalTopRow": 18
        },
        {
          "width": 1142,
          "height": 1420,
          "minDynamicHeight": 24,
          "canEscapeKeyClose": true,
          "animateLoading": true,
          "detachFromLayout": true,
          "canOutsideClickClose": true,
          "shouldScrollContents": true,
          "widgetName": "add_Modal",
          "children": [
            {
              "isVisible": true,
              "widgetName": "Canvas3",
              "version": 1,
              "detachFromLayout": true,
              "flexLayers": [],
              "responsiveBehavior": "fill",
              "minWidth": 450,
              "type": "CANVAS_WIDGET",
              "hideCard": true,
              "isDeprecated": false,
              "displayName": "Canvas",
              "key": "ymn28jtkbi",
              "canExtend": true,
              "isDisabled": false,
              "shouldScrollContents": false,
              "children": [
                {
                  "isVisible": true,
                  "iconName": "Close",
                  "buttonVariant": "TERTIARY",
                  "isDisabled": false,
                  "widgetName": "IconButton1",
                  "version": 1,
                  "animateLoading": true,
                  "responsiveBehavior": "hug",
                  "minWidth": 50,
                  "searchTags": [
                    "click",
                    "submit"
                  ],
                  "type": "ICON_BUTTON_WIDGET",
                  "hideCard": false,
                  "isDeprecated": false,
                  "displayName": "Icon button",
                  "key": "h67v63xm4n",
                  "iconSVG": "./static/media/icon.80fc7466c0d7181ec0271de7fda795ec.svg",
                  "buttonColor": "#52525b",
                  "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                  "iconSize": "50",
                  "widgetId": "f3fmxgimj1",
                  "renderMode": "CANVAS",
                  "boxShadow": "none",
                  "isLoading": false,
                  "leftColumn": 121,
                  "rightColumn": 126,
                  "topRow": 1,
                  "bottomRow": 4,
                  "mobileLeftColumn": 58,
                  "mobileRightColumn": 64,
                  "mobileTopRow": 0,
                  "mobileBottomRow": 4,
                  "parentId": "r6gkycc3fb",
                  "dynamicBindingPathList": [
                    {
                      "key": "borderRadius"
                    }
                  ],
                  "onClick": {
                    "name": "onClick",
                    "status": "add",
                    "label": "触发事件",
                    "children": [
                      {
                        "name": "block",
                        "type": "block",
                        "uid": "86cfc5029dc9476e96465565ef67c910",
                        "children": [
                          {
                            "name": "action",
                            "type": "action",
                            "uid": "befdbce24f604741b90f0845bc2e38eb",
                            "pid": "86cfc5029dc9476e96465565ef67c910",
                            "actionConfig": {
                              "action": "closeModal",
                              "actionId": 178899498243249,
                              "modalName": "add_Modal",
                              "apiTarget": "f3fmxgimj1"
                            }
                          },
                          {
                            "name": "success",
                            "type": "success",
                            "uid": "363c36d4d350494fb25086e81f69626c",
                            "pid": "86cfc5029dc9476e96465565ef67c910"
                          },
                          {
                            "name": "fail",
                            "type": "fail",
                            "uid": "1c2f7847548347d0a1966fd0dfd5e532",
                            "pid": "86cfc5029dc9476e96465565ef67c910"
                          }
                        ]
                      }
                    ]
                  },
                  "dynamicTriggerPathList": [],
                  "iconColor": "#52525b"
                },
                {
                  "isVisible": true,
                  "text": "新增数据",
                  "fontSize": "1.25rem",
                  "fontStyle": "BOLD",
                  "textAlign": "LEFT",
                  "textColor": "#231F20",
                  "cancelBind": false,
                  "length": 0,
                  "widgetName": "Text2",
                  "shouldTruncate": false,
                  "overflow": "NONE",
                  "version": 1,
                  "animateLoading": true,
                  "responsiveBehavior": "fill",
                  "minWidth": 450,
                  "minDynamicHeight": 4,
                  "maxDynamicHeight": 9000,
                  "dynamicHeight": "AUTO_HEIGHT",
                  "searchTags": [
                    "typography",
                    "paragraph",
                    "label"
                  ],
                  "type": "TEXT_WIDGET",
                  "hideCard": false,
                  "isDeprecated": false,
                  "displayName": "Text",
                  "key": "7b8xv1p0ao",
                  "iconSVG": "./static/media/icon.c3b6033f570046f8c6288d911333a827.svg",
                  "widgetId": "c3nzb46btr",
                  "renderMode": "CANVAS",
                  "truncateButtonColor": "{{appsmith.theme.colors.primaryColor}}",
                  "fontFamily": "{{appsmith.theme.fontFamily.appFont}}",
                  "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                  "isLoading": false,
                  "leftColumn": 3,
                  "rightColumn": 43,
                  "topRow": 2,
                  "bottomRow": 6,
                  "mobileLeftColumn": 1,
                  "mobileRightColumn": 41,
                  "mobileTopRow": 1,
                  "mobileBottomRow": 5,
                  "parentId": "r6gkycc3fb",
                  "dynamicBindingPathList": [
                    {
                      "key": "truncateButtonColor"
                    },
                    {
                      "key": "fontFamily"
                    },
                    {
                      "key": "borderRadius"
                    }
                  ],
                  "dynamicTriggerPathList": []
                },
                {
                  "isVisible": true,
                  "borderColor": "#E0DEDE",
                  "borderWidth": "0",
                  "animateLoading": true,
                  "widgetName": "edit_form",
                  "backgroundColor": "#FFFFFF",
                  "children": [
                    {
                      "isVisible": true,
                      "widgetName": "Canvas4",
                      "version": 1,
                      "detachFromLayout": true,
                      "flexLayers": [],
                      "responsiveBehavior": "fill",
                      "minWidth": 450,
                      "type": "CANVAS_WIDGET",
                      "hideCard": true,
                      "isDeprecated": false,
                      "displayName": "Canvas",
                      "key": "ymn28jtkbi",
                      "containerStyle": "none",
                      "canExtend": false,
                      "children": [
                        {
                          "isVisible": true,
                          "label": "布尔",
                          "defaultSwitchState": false,
                          "widgetName": "boolAddForm",
                          "alignWidget": "LEFT",
                          "labelPosition": "Top",
                          "version": 1,
                          "isDisabled": false,
                          "animateLoading": true,
                          "responsiveBehavior": "fill",
                          "labelWidth": 8,
                          "minDynamicHeight": 3,
                          "maxDynamicHeight": 9000,
                          "dynamicHeight": "AUTO_HEIGHT",
                          "searchTags": [
                            "boolean"
                          ],
                          "type": "SWITCH_WIDGET",
                          "hideCard": false,
                          "isDeprecated": false,
                          "displayName": "bool",
                          "key": "8A8F7EC39011162E",
                          "iconSVG": "./static/media/icon.c77450c6a660d2ddf1b49f085348de1c.svg",
                          "widgetId": "22CEFF62F25FAA02",
                          "renderMode": "CANVAS",
                          "accentColor": "{{appsmith.theme.colors.primaryColor}}",
                          "boxShadow": "none",
                          "labelTextColor": "{{appsmith.theme.form.label.fontColor}}",
                          "labelTextSize": "{{appsmith.theme.form.label.fontSize}}",
                          "labelStyle": "{{appsmith.theme.form.label.fontStyle}}",
                          "isLoading": false,
                          "parentColumnSpace": 5.555419921875,
                          "parentRowSpace": 10,
                          "leftColumn": 2,
                          "rightColumn": 62,
                          "topRow": 1,
                          "bottomRow": 6,
                          "mobileLeftColumn": 3,
                          "mobileRightColumn": 15,
                          "mobileTopRow": 36,
                          "mobileBottomRow": 39,
                          "parentId": "6efm58tfjj",
                          "dynamicBindingPathList": [
                            {
                              "key": "accentColor"
                            },
                            {
                              "key": "labelTextColor"
                            },
                            {
                              "key": "labelTextSize"
                            },
                            {
                              "key": "labelStyle"
                            }
                          ],
                          "originalTopRow": 23,
                          "originalBottomRow": 28,
                          "dynamicTriggerPathList": [],
                          "labelText": "布尔"
                        },
                        {
                          "isVisible": true,
                          "isDisabled": false,
                          "isReadonly": false,
                          "datePickerType": "DATE_PICKER",
                          "label": "日期时间",
                          "labelPosition": "Top",
                          "labelAlignment": "right",
                          "placeholderText": "请选择日期",
                          "labelWidth": 5,
                          "labelTextSize": "0.875rem",
                          "dateFormat": "YYYY-MM-DD",
                          "widgetName": "dateTimeAddForm",
                          "defaultDate": "",
                          "minDate": "1920-12-31",
                          "maxDate": "2121-12-31",
                          "version": 2,
                          "isRequired": false,
                          "closeOnSelection": true,
                          "shortcuts": false,
                          "firstDayOfWeek": 0,
                          "timePrecision": "None",
                          "animateLoading": true,
                          "responsiveBehavior": "fill",
                          "minWidth": 450,
                          "minDynamicHeight": 4,
                          "maxDynamicHeight": 9000,
                          "dynamicHeight": "AUTO_HEIGHT",
                          "searchTags": [
                            "calendar"
                          ],
                          "type": "DATE_PICKER_WIDGET2",
                          "hideCard": false,
                          "isDeprecated": false,
                          "displayName": "dateTime",
                          "key": "417331BFB92C06C6",
                          "iconSVG": "./static/media/icon.c8ac755fdc7a44c32deab2390f007005.svg",
                          "widgetId": "360341F4B8AA1213",
                          "renderMode": "CANVAS",
                          "accentColor": "{{appsmith.theme.colors.primaryColor}}",
                          "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                          "boxShadow": "none",
                          "isLoading": false,
                          "parentColumnSpace": 9.21875,
                          "parentRowSpace": 10,
                          "leftColumn": 66,
                          "rightColumn": 126,
                          "topRow": 1,
                          "bottomRow": 6,
                          "mobileLeftColumn": 1,
                          "mobileRightColumn": 21,
                          "mobileTopRow": 14,
                          "mobileBottomRow": 21,
                          "parentId": "6efm58tfjj",
                          "dynamicBindingPathList": [
                            {
                              "key": "accentColor"
                            },
                            {
                              "key": "borderRadius"
                            }
                          ],
                          "originalTopRow": 15,
                          "originalBottomRow": 21,
                          "dynamicTriggerPathList": [],
                          "labelText": "日期时间"
                        },
                        {
                          "isVisible": true,
                          "placeholderText": "请选择",
                          "labelText": "选项",
                          "labelPosition": "Top",
                          "labelAlignment": "right",
                          "labelWidth": 8,
                          "selectId": 366465321725578,
                          "defaultOptions": [],
                          "serverSideFiltering": false,
                          "widgetName": "dictAddForm",
                          "defaultOptionValue": "",
                          "defaultOptionLabel": null,
                          "version": 1,
                          "isFilterable": true,
                          "isRequired": false,
                          "isDisabled": false,
                          "isReadonly": false,
                          "animateLoading": true,
                          "responsiveBehavior": "fill",
                          "minWidth": 375,
                          "minDynamicHeight": 3,
                          "maxDynamicHeight": 9000,
                          "dynamicHeight": "AUTO_HEIGHT",
                          "searchTags": [
                            "dropdown"
                          ],
                          "type": "SELECT_WIDGET",
                          "hideCard": false,
                          "isDeprecated": false,
                          "displayName": "dict",
                          "key": "24B5E1B22CBDE2A9",
                          "iconSVG": "./static/media/icon.1a5defb3c19b4cac4a27829d1f979e4c.svg",
                          "widgetId": "044CA3AAB7AC1750",
                          "renderMode": "CANVAS",
                          "accentColor": "{{appsmith.theme.colors.primaryColor}}",
                          "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                          "boxShadow": "{{appsmith.theme.boxShadow.appBoxShadow}}",
                          "it_color": "{{appsmith.theme.form.inputText.fontColor}}",
                          "it_size": "{{appsmith.theme.form.inputText.fontSize}}",
                          "it_style": "{{appsmith.theme.form.inputText.fontStyle}}",
                          "labelTextColor": "{{appsmith.theme.form.label.fontColor}}",
                          "labelTextSize": "{{appsmith.theme.form.label.fontSize}}",
                          "labelStyle": "{{appsmith.theme.form.label.fontStyle}}",
                          "ib_bgColor": "{{appsmith.theme.form.inputBorder.bgColor}}",
                          "ib_borderColor": "{{appsmith.theme.form.inputBorder.bgBorderColor}}",
                          "isLoading": false,
                          "parentColumnSpace": 5.555419921875,
                          "parentRowSpace": 10,
                          "leftColumn": 2,
                          "rightColumn": 62,
                          "topRow": 7,
                          "bottomRow": 13,
                          "mobileLeftColumn": 17,
                          "mobileRightColumn": 45,
                          "mobileTopRow": 10,
                          "mobileBottomRow": 13,
                          "parentId": "6efm58tfjj",
                          "dynamicBindingPathList": [
                            {
                              "key": "accentColor"
                            },
                            {
                              "key": "borderRadius"
                            },
                            {
                              "key": "boxShadow"
                            },
                            {
                              "key": "it_color"
                            },
                            {
                              "key": "it_size"
                            },
                            {
                              "key": "it_style"
                            },
                            {
                              "key": "labelTextColor"
                            },
                            {
                              "key": "labelTextSize"
                            },
                            {
                              "key": "labelStyle"
                            },
                            {
                              "key": "ib_bgColor"
                            },
                            {
                              "key": "ib_borderColor"
                            }
                          ],
                          "dynamicTriggerPathList": [],
                          "originalTopRow": 8,
                          "originalBottomRow": 14,
                          "label": "选项",
                        },
                        {
                          "isVisible": true,
                          "label": "邮箱",
                          "labelPosition": "Top",
                          "labelAlignment": "right",
                          "labelWidth": 8,
                          "widgetName": "emailAddForm",
                          "version": 2,
                          "iconAlign": "left",
                          "autoFocus": false,
                          "resetOnSubmit": true,
                          "isRequired": false,
                          "isDisabled": false,
                          "readonly": false,
                          "animateLoading": true,
                          "responsiveBehavior": "fill",
                          "minWidth": 375,
                          "inputType": "EMAIL",
                          "showStepArrows": false,
                          "isCount": false,
                          "minDynamicHeight": 3,
                          "maxDynamicHeight": 9000,
                          "dynamicHeight": "AUTO_HEIGHT",
                          "searchTags": [
                            "form",
                            "text input",
                            "number",
                            "textarea"
                          ],
                          "type": "INPUT_WIDGET_V2",
                          "hideCard": false,
                          "isDeprecated": false,
                          "displayName": "email",
                          "key": "C4BBAFC9F87515F3",
                          "iconSVG": "./static/media/icon.d0ce957b6c4640f8a7418ce846ee200e.svg",
                          "widgetId": "220E94BAA8402A8C",
                          "renderMode": "CANVAS",
                          "accentColor": "{{appsmith.theme.colors.primaryColor}}",
                          "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                          "boxShadow": "{{appsmith.theme.boxShadow.appBoxShadow}}",
                          "it_color": "{{appsmith.theme.form.inputText.fontColor}}",
                          "it_size": "{{appsmith.theme.form.inputText.fontSize}}",
                          "it_style": "{{appsmith.theme.form.inputText.fontStyle}}",
                          "labelTextColor": "{{appsmith.theme.form.label.fontColor}}",
                          "labelTextSize": "{{appsmith.theme.form.label.fontSize}}",
                          "labelStyle": "{{appsmith.theme.form.label.fontStyle}}",
                          "ib_bgColor": "{{appsmith.theme.form.inputBorder.bgColor}}",
                          "ib_borderColor": "{{appsmith.theme.form.inputBorder.bgBorderColor}}",
                          "isLoading": false,
                          "parentColumnSpace": 8.503662109375,
                          "parentRowSpace": 10,
                          "leftColumn": 66,
                          "rightColumn": 126,
                          "topRow": 7,
                          "bottomRow": 13,
                          "mobileLeftColumn": 2,
                          "mobileRightColumn": 30,
                          "mobileTopRow": 148,
                          "mobileBottomRow": 151,
                          "parentId": "6efm58tfjj",
                          "dynamicBindingPathList": [
                            {
                              "key": "accentColor"
                            },
                            {
                              "key": "borderRadius"
                            },
                            {
                              "key": "boxShadow"
                            },
                            {
                              "key": "it_color"
                            },
                            {
                              "key": "it_size"
                            },
                            {
                              "key": "it_style"
                            },
                            {
                              "key": "labelTextColor"
                            },
                            {
                              "key": "labelTextSize"
                            },
                            {
                              "key": "labelStyle"
                            },
                            {
                              "key": "ib_bgColor"
                            },
                            {
                              "key": "ib_borderColor"
                            }
                          ],
                          "dynamicTriggerPathList": [],
                          "shouldAllowAutofill": true,
                          "originalTopRow": 30,
                          "originalBottomRow": 36,
                          "labelText": "邮箱",
                          "defaultText": ""
                        },
                        {
                          "isVisible": true,
                          "defaultImage": "https://assets.appsmith.com/widgets/default.png",
                          "imageShape": "RECTANGLE",
                          "maxZoomLevel": 1,
                          "enableRotation": false,
                          "enableDownload": false,
                          "objectFit": "cover",
                          "image": "",
                          "widgetName": "fileAddForm",
                          "version": 1,
                          "animateLoading": true,
                          "value": "[]",
                          "label": "文件",
                          "labelPosition": "Top",
                          "labelWidth": 8,
                          "accept": "",
                          "fileSize": 10,
                          "fileCount": 1,
                          "disabled": false,
                          "labelAlignment": "right",
                          "btnText": "点击上传文件",
                          "defaultValue": "[]",
                          "minDynamicHeight": 3,
                          "maxDynamicHeight": 9000,
                          "dynamicHeight": "AUTO_HEIGHT",
                          "type": "UPLOAD_WIDGET",
                          "hideCard": false,
                          "isDeprecated": false,
                          "displayName": "file",
                          "key": "F71D812B2CBE83DD",
                          "iconSVG": "./static/media/icon.2c8bfbc118a7a5f7b61b10540a4a8881.svg",
                          "widgetId": "7F6E5EE960637CCD",
                          "renderMode": "CANVAS",
                          "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                          "boxShadow": "{{appsmith.theme.boxShadow.appBoxShadow}}",
                          "accentColor": "{{appsmith.theme.colors.primaryColor}}",
                          "labelTextColor": "{{appsmith.theme.form.label.fontColor}}",
                          "labelTextSize": "{{appsmith.theme.form.label.fontSize}}",
                          "labelStyle": "{{appsmith.theme.form.label.fontStyle}}",
                          "isLoading": false,
                          "parentColumnSpace": 5.555419921875,
                          "parentRowSpace": 10,
                          "leftColumn": 2,
                          "rightColumn": 126,
                          "topRow": 14,
                          "bottomRow": 21,
                          "mobileLeftColumn": 3,
                          "mobileRightColumn": 33,
                          "mobileTopRow": 57,
                          "mobileBottomRow": 60,
                          "parentId": "6efm58tfjj",
                          "dynamicBindingPathList": [
                            {
                              "key": "borderRadius"
                            },
                            {
                              "key": "boxShadow"
                            },
                            {
                              "key": "accentColor"
                            },
                            {
                              "key": "labelTextColor"
                            },
                            {
                              "key": "labelTextSize"
                            },
                            {
                              "key": "labelStyle"
                            }
                          ],
                          "originalTopRow": 45,
                          "originalBottomRow": 52,
                          "dynamicTriggerPathList": [],
                          "labelText": "文件"
                        },
                        {
                          "isVisible": true,
                          "label": "小数",
                          "labelPosition": "Top",
                          "labelAlignment": "right",
                          "labelWidth": 8,
                          "widgetName": "floatAddForm",
                          "version": 2,
                          "iconAlign": "left",
                          "autoFocus": false,
                          "resetOnSubmit": true,
                          "isRequired": false,
                          "isDisabled": false,
                          "readonly": false,
                          "animateLoading": true,
                          "responsiveBehavior": "fill",
                          "minWidth": 375,
                          "inputType": "NUMBER",
                          "showStepArrows": false,
                          "isCount": false,
                          "minDynamicHeight": 3,
                          "maxDynamicHeight": 9000,
                          "dynamicHeight": "AUTO_HEIGHT",
                          "searchTags": [
                            "form",
                            "text input",
                            "number",
                            "textarea"
                          ],
                          "type": "INPUT_WIDGET_V2",
                          "hideCard": false,
                          "isDeprecated": false,
                          "displayName": "float",
                          "key": "646208454DD79A39",
                          "iconSVG": "/static/media/icon.d0ce957b6c4640f8a7418ce846ee200e.svg",
                          "widgetId": "FB623A280550F970",
                          "renderMode": "CANVAS",
                          "accentColor": "{{appsmith.theme.colors.primaryColor}}",
                          "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                          "boxShadow": "{{appsmith.theme.boxShadow.appBoxShadow}}",
                          "it_color": "{{appsmith.theme.form.inputText.fontColor}}",
                          "it_size": "{{appsmith.theme.form.inputText.fontSize}}",
                          "it_style": "{{appsmith.theme.form.inputText.fontStyle}}",
                          "labelTextColor": "{{appsmith.theme.form.label.fontColor}}",
                          "labelTextSize": "{{appsmith.theme.form.label.fontSize}}",
                          "labelStyle": "{{appsmith.theme.form.label.fontStyle}}",
                          "ib_bgColor": "{{appsmith.theme.form.inputBorder.bgColor}}",
                          "ib_borderColor": "{{appsmith.theme.form.inputBorder.bgBorderColor}}",
                          "isLoading": false,
                          "parentColumnSpace": 8.503662109375,
                          "parentRowSpace": 10,
                          "leftColumn": 2,
                          "rightColumn": 62,
                          "topRow": 22,
                          "bottomRow": 28,
                          "mobileLeftColumn": 2,
                          "mobileRightColumn": 30,
                          "mobileTopRow": 57,
                          "mobileBottomRow": 60,
                          "parentId": "6efm58tfjj",
                          "dynamicBindingPathList": [
                            {
                              "key": "accentColor"
                            },
                            {
                              "key": "borderRadius"
                            },
                            {
                              "key": "boxShadow"
                            },
                            {
                              "key": "it_color"
                            },
                            {
                              "key": "it_size"
                            },
                            {
                              "key": "it_style"
                            },
                            {
                              "key": "labelTextColor"
                            },
                            {
                              "key": "labelTextSize"
                            },
                            {
                              "key": "labelStyle"
                            },
                            {
                              "key": "ib_bgColor"
                            },
                            {
                              "key": "ib_borderColor"
                            }
                          ],
                          "dynamicTriggerPathList": [],
                          "originalTopRow": 38,
                          "originalBottomRow": 44,
                          "shouldAllowAutofill": false,
                          "labelText": "小数",
                          "defaultText": ""
                        },
                        {
                          "isVisible": true,
                          "dynamicHeight": "AUTO_HEIGHT",
                          "defaultImage": "https://assets.appsmith.com/widgets/default.png",
                          "imageShape": "RECTANGLE",
                          "maxZoomLevel": 1,
                          "enableRotation": false,
                          "enableDownload": false,
                          "objectFit": "cover",
                          "image": "",
                          "widgetName": "imageAddForm",
                          "version": 1,
                          "animateLoading": true,
                          "value": "[]",
                          "label": "图片",
                          "labelPosition": "Top",
                          "labelWidth": 8,
                          "fileSize": 10,
                          "fileCount": 1,
                          "disabled": false,
                          "labelAlignment": "right",
                          "btnText": "上传",
                          "accept": ".jpg,.jpeg,.png",
                          "defaultValue": "[]",
                          "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                          "type": "UPLOAD_IMAGE_WIDGET",
                          "hideCard": false,
                          "isDeprecated": false,
                          "displayName": "image",
                          "key": "E3E0C1945677CA94",
                          "iconSVG": "./static/media/icon.30c8cbd442cce232b01ba2d434c53a53.svg",
                          "widgetId": "6807010E5649F261",
                          "renderMode": "CANVAS",
                          "boxShadow": "{{appsmith.theme.boxShadow.appBoxShadow}}",
                          "accentColor": "{{appsmith.theme.colors.primaryColor}}",
                          "labelTextColor": "{{appsmith.theme.form.label.fontColor}}",
                          "labelTextSize": "{{appsmith.theme.form.label.fontSize}}",
                          "labelStyle": "{{appsmith.theme.form.label.fontStyle}}",
                          "isLoading": false,
                          "parentColumnSpace": 7.11865234375,
                          "parentRowSpace": 10,
                          "leftColumn": 66,
                          "rightColumn": 95,
                          "topRow": 22,
                          "bottomRow": 28,
                          "mobileLeftColumn": 3,
                          "mobileRightColumn": 29,
                          "mobileTopRow": 64,
                          "mobileBottomRow": 73,
                          "parentId": "6efm58tfjj",
                          "dynamicBindingPathList": [
                            {
                              "key": "borderRadius"
                            },
                            {
                              "key": "boxShadow"
                            },
                            {
                              "key": "accentColor"
                            },
                            {
                              "key": "labelTextColor"
                            },
                            {
                              "key": "labelTextSize"
                            },
                            {
                              "key": "labelStyle"
                            }
                          ],
                          "originalTopRow": 53,
                          "originalBottomRow": 66,
                          "dynamicTriggerPathList": [],
                          "labelText": "图片"
                        },
                        {
                          "isVisible": true,
                          "defaultImage": "https://assets.appsmith.com/widgets/default.png",
                          "imageShape": "RECTANGLE",
                          "maxZoomLevel": 1,
                          "enableRotation": false,
                          "enableDownload": false,
                          "objectFit": "cover",
                          "image": "",
                          "widgetName": "intAddForm",
                          "version": 1,
                          "animateLoading": true,
                          "value": "100",
                          "showTime": false,
                          "placeholderText1": "请选择开始日期",
                          "placeholderText2": "请选择结束日期",
                          "labelText": "整数",
                          "labelPosition": "Top",
                          "labelAlignment": "right",
                          "labelWidth": 8,
                          "Min": 0,
                          "Max": 9999,
                          "defaultValue": "",
                          "readOnly": false,
                          "stringMode": false,
                          "minDynamicHeight": 3,
                          "maxDynamicHeight": 9000,
                          "dynamicHeight": "AUTO_HEIGHT",
                          "type": "INPUTNUMBER_WIDGET",
                          "hideCard": false,
                          "isDeprecated": false,
                          "displayName": "int",
                          "key": "203A34640D8BA6FA",
                          "iconSVG": "./static/media/icon.7824b9f0c785293524b78ae91a727700.svg",
                          "widgetId": "F838B645FADBCD84",
                          "renderMode": "CANVAS",
                          "accentColor": "{{appsmith.theme.colors.primaryColor}}",
                          "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                          "boxShadow": "{{appsmith.theme.boxShadow.appBoxShadow}}",
                          "it_color": "{{appsmith.theme.form.inputText.fontColor}}",
                          "it_size": "{{appsmith.theme.form.inputText.fontSize}}",
                          "it_style": "{{appsmith.theme.form.inputText.fontStyle}}",
                          "labelTextColor": "{{appsmith.theme.form.label.fontColor}}",
                          "labelTextSize": "{{appsmith.theme.form.label.fontSize}}",
                          "labelStyle": "{{appsmith.theme.form.label.fontStyle}}",
                          "ib_bgColor": "{{appsmith.theme.form.inputBorder.bgColor}}",
                          "ib_borderColor": "{{appsmith.theme.form.inputBorder.bgBorderColor}}",
                          "isLoading": false,
                          "parentColumnSpace": 5.555419921875,
                          "parentRowSpace": 10,
                          "leftColumn": 2,
                          "rightColumn": 62,
                          "topRow": 29,
                          "bottomRow": 35,
                          "mobileLeftColumn": 3,
                          "mobileRightColumn": 31,
                          "mobileTopRow": 42,
                          "mobileBottomRow": 45,
                          "parentId": "6efm58tfjj",
                          "dynamicBindingPathList": [
                            {
                              "key": "accentColor"
                            },
                            {
                              "key": "borderRadius"
                            },
                            {
                              "key": "boxShadow"
                            },
                            {
                              "key": "it_color"
                            },
                            {
                              "key": "it_size"
                            },
                            {
                              "key": "it_style"
                            },
                            {
                              "key": "labelTextColor"
                            },
                            {
                              "key": "labelTextSize"
                            },
                            {
                              "key": "labelStyle"
                            },
                            {
                              "key": "ib_bgColor"
                            },
                            {
                              "key": "ib_borderColor"
                            }
                          ],
                          "dynamicTriggerPathList": [],
                          "originalTopRow": 22,
                          "originalBottomRow": 28,
                          "shouldScrollContents": true,
                          "label": "整数"
                        },
                        {
                          "isVisible": true,
                          "label": "单行文本",
                          "labelPosition": "Top",
                          "labelAlignment": "right",
                          "labelTextSize": "0.875rem",
                          "labelWidth": "10",
                          "widgetName": "lineTextAddForm",
                          "version": 2,
                          "defaultText": "",
                          "iconAlign": "left",
                          "autoFocus": false,
                          "labelStyle": "",
                          "resetOnSubmit": true,
                          "isRequired": true,
                          "isDisabled": false,
                          "readonly": false,
                          "animateLoading": true,
                          "responsiveBehavior": "fill",
                          "minWidth": 450,
                          "inputType": "TEXT",
                          "showStepArrows": false,
                          "isCount": false,
                          "minDynamicHeight": 4,
                          "maxDynamicHeight": 9000,
                          "dynamicHeight": "AUTO_HEIGHT",
                          "searchTags": [
                            "form",
                            "text input",
                            "number",
                            "textarea"
                          ],
                          "type": "INPUT_WIDGET_V2",
                          "hideCard": false,
                          "isDeprecated": false,
                          "displayName": "lineText",
                          "key": "A3C875C0DE92C994",
                          "iconSVG": "./static/media/icon.d0ce957b6c4640f8a7418ce846ee200e.svg",
                          "widgetId": "CD993C45EB5DD34F",
                          "renderMode": "CANVAS",
                          "accentColor": "{{appsmith.theme.colors.primaryColor}}",
                          "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                          "boxShadow": "none",
                          "isLoading": false,
                          "parentColumnSpace": 6.9375,
                          "parentRowSpace": 10,
                          "leftColumn": 66,
                          "rightColumn": 126,
                          "topRow": 29,
                          "bottomRow": 35,
                          "mobileLeftColumn": 1,
                          "mobileRightColumn": 21,
                          "mobileTopRow": 6,
                          "mobileBottomRow": 13,
                          "parentId": "6efm58tfjj",
                          "dynamicBindingPathList": [
                            {
                              "key": "accentColor"
                            },
                            {
                              "key": "borderRadius"
                            }
                          ],
                          "originalTopRow": 1,
                          "originalBottomRow": 7,
                          "dynamicTriggerPathList": [],
                          "labelText": "单行文本"
                        },
                        {
                          "isVisible": true,
                          "defaultImage": "https://assets.appsmith.com/widgets/default.png",
                          "imageShape": "RECTANGLE",
                          "maxZoomLevel": 1,
                          "enableRotation": false,
                          "enableDownload": false,
                          "objectFit": "cover",
                          "image": "",
                          "widgetName": "longIntAddForm",
                          "version": 1,
                          "animateLoading": true,
                          "value": "100",
                          "showTime": false,
                          "placeholderText1": "请选择开始日期",
                          "placeholderText2": "请选择结束日期",
                          "labelText": "长整数",
                          "labelPosition": "Top",
                          "labelAlignment": "right",
                          "labelWidth": 8,
                          "Min": 0,
                          "Max": 9999,
                          "defaultValue": "",
                          "readOnly": false,
                          "stringMode": false,
                          "minDynamicHeight": 3,
                          "maxDynamicHeight": 9000,
                          "dynamicHeight": "AUTO_HEIGHT",
                          "type": "INPUTNUMBER_WIDGET",
                          "hideCard": false,
                          "isDeprecated": false,
                          "displayName": "longInt",
                          "key": "E069BA0AEEB5A163",
                          "iconSVG": "./static/media/icon.7824b9f0c785293524b78ae91a727700.svg",
                          "widgetId": "88AE7D6C872EC33F",
                          "renderMode": "CANVAS",
                          "accentColor": "{{appsmith.theme.colors.primaryColor}}",
                          "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                          "boxShadow": "{{appsmith.theme.boxShadow.appBoxShadow}}",
                          "it_color": "{{appsmith.theme.form.inputText.fontColor}}",
                          "it_size": "{{appsmith.theme.form.inputText.fontSize}}",
                          "it_style": "{{appsmith.theme.form.inputText.fontStyle}}",
                          "labelTextColor": "{{appsmith.theme.form.label.fontColor}}",
                          "labelTextSize": "{{appsmith.theme.form.label.fontSize}}",
                          "labelStyle": "{{appsmith.theme.form.label.fontStyle}}",
                          "ib_bgColor": "{{appsmith.theme.form.inputBorder.bgColor}}",
                          "ib_borderColor": "{{appsmith.theme.form.inputBorder.bgBorderColor}}",
                          "isLoading": false,
                          "parentColumnSpace": 5.555419921875,
                          "parentRowSpace": 10,
                          "leftColumn": 2,
                          "rightColumn": 62,
                          "topRow": 36,
                          "bottomRow": 42,
                          "mobileLeftColumn": 3,
                          "mobileRightColumn": 31,
                          "mobileTopRow": 42,
                          "mobileBottomRow": 45,
                          "parentId": "6efm58tfjj",
                          "dynamicBindingPathList": [
                            {
                              "key": "accentColor"
                            },
                            {
                              "key": "borderRadius"
                            },
                            {
                              "key": "boxShadow"
                            },
                            {
                              "key": "it_color"
                            },
                            {
                              "key": "it_size"
                            },
                            {
                              "key": "it_style"
                            },
                            {
                              "key": "labelTextColor"
                            },
                            {
                              "key": "labelTextSize"
                            },
                            {
                              "key": "labelStyle"
                            },
                            {
                              "key": "ib_bgColor"
                            },
                            {
                              "key": "ib_borderColor"
                            }
                          ],
                          "dynamicTriggerPathList": [],
                          "originalTopRow": 22,
                          "originalBottomRow": 28,
                          "shouldScrollContents": true,
                          "label": "长整数"
                        },
                        {
                          "isVisible": true,
                          "label": "多行文本",
                          "labelPosition": "Top",
                          "labelAlignment": "right",
                          "labelWidth": 8,
                          "widgetName": "moreLineTextAddForm",
                          "version": 2,
                          "iconAlign": "left",
                          "autoFocus": false,
                          "resetOnSubmit": true,
                          "isRequired": false,
                          "isDisabled": false,
                          "readonly": false,
                          "animateLoading": true,
                          "responsiveBehavior": "fill",
                          "minWidth": 375,
                          "inputType": "MULTI_LINE_TEXT",
                          "showStepArrows": false,
                          "isCount": false,
                          "minDynamicHeight": 3,
                          "maxDynamicHeight": 9000,
                          "dynamicHeight": "AUTO_HEIGHT",
                          "searchTags": [
                            "form",
                            "text input",
                            "number",
                            "textarea"
                          ],
                          "type": "INPUT_WIDGET_V2",
                          "hideCard": false,
                          "isDeprecated": false,
                          "displayName": "moreLineText",
                          "key": "F0713DDA848E5206",
                          "iconSVG": "./static/media/icon.d0ce957b6c4640f8a7418ce846ee200e.svg",
                          "widgetId": "592B7E1371B8FE16",
                          "renderMode": "CANVAS",
                          "accentColor": "{{appsmith.theme.colors.primaryColor}}",
                          "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                          "boxShadow": "{{appsmith.theme.boxShadow.appBoxShadow}}",
                          "it_color": "{{appsmith.theme.form.inputText.fontColor}}",
                          "it_size": "{{appsmith.theme.form.inputText.fontSize}}",
                          "it_style": "{{appsmith.theme.form.inputText.fontStyle}}",
                          "labelTextColor": "{{appsmith.theme.form.label.fontColor}}",
                          "labelTextSize": "{{appsmith.theme.form.label.fontSize}}",
                          "labelStyle": "{{appsmith.theme.form.label.fontStyle}}",
                          "ib_bgColor": "{{appsmith.theme.form.inputBorder.bgColor}}",
                          "ib_borderColor": "{{appsmith.theme.form.inputBorder.bgBorderColor}}",
                          "isLoading": false,
                          "parentColumnSpace": 8.503662109375,
                          "parentRowSpace": 10,
                          "leftColumn": 66,
                          "rightColumn": 126,
                          "topRow": 36,
                          "bottomRow": 42,
                          "mobileLeftColumn": 67,
                          "mobileRightColumn": 95,
                          "mobileTopRow": 46,
                          "mobileBottomRow": 49,
                          "parentId": "6efm58tfjj",
                          "dynamicBindingPathList": [
                            {
                              "key": "accentColor"
                            },
                            {
                              "key": "borderRadius"
                            },
                            {
                              "key": "boxShadow"
                            },
                            {
                              "key": "it_color"
                            },
                            {
                              "key": "it_size"
                            },
                            {
                              "key": "it_style"
                            },
                            {
                              "key": "labelTextColor"
                            },
                            {
                              "key": "labelTextSize"
                            },
                            {
                              "key": "labelStyle"
                            },
                            {
                              "key": "ib_bgColor"
                            },
                            {
                              "key": "ib_borderColor"
                            }
                          ],
                          "dynamicTriggerPathList": [],
                          "originalTopRow": 30,
                          "originalBottomRow": 39,
                          "shouldAllowAutofill": false,
                          "labelText": "多行文本",
                          "defaultText": ""
                        },
                        {
                          "isVisible": true,
                          "defaultValue": "佰易开低代码开发平台",
                          "value": "",
                          "animateLoading": true,
                          "isDisabled": false,
                          "isReadonly": false,
                          "isRequired": false,
                          "widgetName": "richTextAddForm",
                          "isDefaultClickDisabled": true,
                          "inputType": "html",
                          "labelText": "富文本",
                          "labelPosition": "Top",
                          "labelAlignment": "right",
                          "labelWidth": 8,
                          "borderWidth": 1,
                          "borderColor": "{{appsmith.theme.form.inputBorder.bgBorderColor}}",
                          "version": 1,
                          "responsiveBehavior": "fill",
                          "minWidth": 375,
                          "backgroundColor": "#fff",
                          "minDynamicHeight": 3,
                          "maxDynamicHeight": 9000,
                          "dynamicHeight": "FIXED",
                          "searchTags": [
                            "input",
                            "rte"
                          ],
                          "type": "RICH_TEXT_EDITOR_WIDGET",
                          "hideCard": false,
                          "isDeprecated": false,
                          "displayName": "richText",
                          "key": "DD45CC6B04D5C7F2",
                          "iconSVG": "./static/media/icon.cbb4ba403a42ccddcd5d4bb23ae7b4c9.svg",
                          "widgetId": "0C0FD62EB066A5D3",
                          "renderMode": "CANVAS",
                          "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                          "boxShadow": "{{appsmith.theme.boxShadow.appBoxShadow}}",
                          "labelTextColor": "{{appsmith.theme.form.label.fontColor}}",
                          "labelTextSize": "{{appsmith.theme.form.label.fontSize}}",
                          "labelStyle": "{{appsmith.theme.form.label.fontStyle}}",
                          "fontColor": "{{appsmith.theme.form.inputText.fontColor}}",
                          "ib_bgColor": "{{appsmith.theme.form.inputBorder.bgColor}}",
                          "isLoading": false,
                          "parentColumnSpace": 8.503662109375,
                          "parentRowSpace": 10,
                          "leftColumn": 2,
                          "rightColumn": 129,
                          "topRow": 43,
                          "bottomRow": 85,
                          "mobileLeftColumn": 0,
                          "mobileRightColumn": 80,
                          "mobileTopRow": 71,
                          "mobileBottomRow": 117,
                          "parentId": "6efm58tfjj",
                          "dynamicBindingPathList": [
                            {
                              "key": "borderRadius"
                            },
                            {
                              "key": "boxShadow"
                            },
                            {
                              "key": "labelTextColor"
                            },
                            {
                              "key": "labelTextSize"
                            },
                            {
                              "key": "labelStyle"
                            },
                            {
                              "key": "fontColor"
                            },
                            {
                              "key": "ib_bgColor"
                            },
                            {
                              "key": "borderColor"
                            }
                          ],
                          "dynamicTriggerPathList": [],
                          "label": "富文本",
                          "defaultText": ""
                        },
                        {
                          "isVisible": true,
                          "rowSpan": 1,
                          "widgetName": "childrenAddFormSubTable",
                          "version": 1,
                          "animateLoading": true,
                          "value": [],
                          "defaultValue": [],
                          "label": "children",
                          "labelPosition": "Top",
                          "labelWidth": 8,
                          "vertical": false,
                          "labelAlignment": "right",
                          "isDisabled": false,
                          "tableColumns": {},
                          "fixTableColumns": {
                            "id": {
                              "id": "id",
                              "index": 0,
                              "label": "id",
                              "columnType": "text"
                            },
                            "action": {
                              "id": "_subTable_action",
                              "index": 1,
                              "label": "增删改标记",
                              "columnType": "text"
                            }
                          },
                          "minDynamicHeight": 3,
                          "maxDynamicHeight": 9000,
                          "dynamicHeight": "AUTO_HEIGHT",
                          "type": "SUB_TABLE_WIDGET",
                          "hideCard": false,
                          "isDeprecated": false,
                          "displayName": "children",
                          "key": "559FEF671CEFBB39",
                          "iconSVG": "./static/media/icon.24905525921dd6f5ff46d0dd843b9e12.svg",
                          "widgetId": "5C5D261E2F9171E1",
                          "renderMode": "CANVAS",
                          "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                          "boxShadow": "{{appsmith.theme.boxShadow.appBoxShadow}}",
                          "labelTextColor": "{{appsmith.theme.form.label.fontColor}}",
                          "labelTextSize": "{{appsmith.theme.form.label.fontSize}}",
                          "labelStyle": "{{appsmith.theme.form.label.fontStyle}}",
                          "accentColor": "{{appsmith.theme.colors.primaryColor}}",
                          "opBtnBgColor": "{{appsmith.theme.colors.primaryColor}}",
                          "opBtnColor": "{{appsmith.theme.colors.primaryColor}}",
                          "newBtnColor": "{{appsmith.theme.colors.primaryColor}}",
                          "newBtnBgColor": "{{appsmith.theme.colors.primaryColor}}",
                          "opBtnType": "SECONDARY",
                          "newBtnType": "TERTIARY",
                          "isLoading": false,
                          "parentColumnSpace": 5.555419921875,
                          "parentRowSpace": 10,
                          "leftColumn": 2,
                          "rightColumn": 126,
                          "topRow": 86,
                          "bottomRow": 117,
                          "mobileLeftColumn": 2,
                          "mobileRightColumn": 62,
                          "mobileTopRow": 77,
                          "mobileBottomRow": 101,
                          "parentId": "6efm58tfjj",
                          "dynamicBindingPathList": [
                            {
                              "key": "borderRadius"
                            },
                            {
                              "key": "boxShadow"
                            },
                            {
                              "key": "labelTextColor"
                            },
                            {
                              "key": "labelTextSize"
                            },
                            {
                              "key": "labelStyle"
                            },
                            {
                              "key": "accentColor"
                            },
                            {
                              "key": "opBtnBgColor"
                            },
                            {
                              "key": "opBtnColor"
                            },
                            {
                              "key": "newBtnColor"
                            },
                            {
                              "key": "newBtnBgColor"
                            }
                          ],
                          "originalTopRow": 121,
                          "originalBottomRow": 152,
                          "dynamicTriggerPathList": [],
                          "labelText": "children"
                        },
                        {
                          "isVisible": true,
                          "placeholderText": "请选择",
                          "labelText": "parentMainId",
                          "labelPosition": "Top",
                          "labelAlignment": "right",
                          "labelWidth": 8,
                          "selectId": null,
                          "defaultOptions": [],
                          "serverSideFiltering": false,
                          "widgetName": "parentMainIdAddForm",
                          "defaultOptionValue": "",
                          "defaultOptionLabel": null,
                          "version": 1,
                          "isFilterable": true,
                          "isRequired": false,
                          "isDisabled": false,
                          "isReadonly": false,
                          "animateLoading": true,
                          "responsiveBehavior": "fill",
                          "minWidth": 375,
                          "minDynamicHeight": 3,
                          "maxDynamicHeight": 9000,
                          "dynamicHeight": "AUTO_HEIGHT",
                          "searchTags": [
                            "dropdown"
                          ],
                          "type": "SELECT_WIDGET",
                          "hideCard": false,
                          "isDeprecated": false,
                          "displayName": "parentMainId",
                          "key": "F99A20ECF6E4C599",
                          "iconSVG": "./static/media/icon.1a5defb3c19b4cac4a27829d1f979e4c.svg",
                          "widgetId": "BAD9C57571A4F313",
                          "renderMode": "CANVAS",
                          "accentColor": "{{appsmith.theme.colors.primaryColor}}",
                          "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                          "boxShadow": "{{appsmith.theme.boxShadow.appBoxShadow}}",
                          "it_color": "{{appsmith.theme.form.inputText.fontColor}}",
                          "it_size": "{{appsmith.theme.form.inputText.fontSize}}",
                          "it_style": "{{appsmith.theme.form.inputText.fontStyle}}",
                          "labelTextColor": "{{appsmith.theme.form.label.fontColor}}",
                          "labelTextSize": "{{appsmith.theme.form.label.fontSize}}",
                          "labelStyle": "{{appsmith.theme.form.label.fontStyle}}",
                          "ib_bgColor": "{{appsmith.theme.form.inputBorder.bgColor}}",
                          "ib_borderColor": "{{appsmith.theme.form.inputBorder.bgBorderColor}}",
                          "isLoading": false,
                          "parentColumnSpace": 5.555419921875,
                          "parentRowSpace": 10,
                          "leftColumn": 2,
                          "rightColumn": 62,
                          "topRow": 118,
                          "bottomRow": 124,
                          "mobileLeftColumn": 17,
                          "mobileRightColumn": 45,
                          "mobileTopRow": 10,
                          "mobileBottomRow": 13,
                          "parentId": "6efm58tfjj",
                          "dynamicBindingPathList": [
                            {
                              "key": "accentColor"
                            },
                            {
                              "key": "borderRadius"
                            },
                            {
                              "key": "boxShadow"
                            },
                            {
                              "key": "it_color"
                            },
                            {
                              "key": "it_size"
                            },
                            {
                              "key": "it_style"
                            },
                            {
                              "key": "labelTextColor"
                            },
                            {
                              "key": "labelTextSize"
                            },
                            {
                              "key": "labelStyle"
                            },
                            {
                              "key": "ib_bgColor"
                            },
                            {
                              "key": "ib_borderColor"
                            }
                          ],
                          "dynamicTriggerPathList": [],
                          "originalTopRow": 8,
                          "originalBottomRow": 14,
                          "label": "parentMainId",
                        },
                        {
                          "isVisible": true,
                          "animateLoading": true,
                          "text": "提交",
                          "buttonVariant": "PRIMARY",
                          "placement": "CENTER",
                          "widgetName": "CreateBtn",
                          "isDisabled": false,
                          "isDefaultClickDisabled": true,
                          "disabledWhenInvalid": true,
                          "resetFormOnClick": false,
                          "recaptchaType": "V3",
                          "version": 1,
                          "borderRadius": "0.375rem",
                          "responsiveBehavior": "hug",
                          "minWidth": 120,
                          "searchTags": [
                            "click",
                            "submit"
                          ],
                          "type": "BUTTON_WIDGET",
                          "hideCard": false,
                          "isDeprecated": false,
                          "displayName": "Button",
                          "key": "E915E992CBA24089",
                          "iconSVG": "./static/media/icon.2075e59f4c855dc62f664870206244a0.svg",
                          "widgetId": "061D10389001E1D4",
                          "renderMode": "CANVAS",
                          "buttonColor": "{{appsmith.theme.colors.primaryColor}}",
                          "boxShadow": "none",
                          "isLoading": false,
                          "leftColumn": 115,
                          "rightColumn": 126,
                          "topRow": 129,
                          "bottomRow": 132,
                          "mobileLeftColumn": 46,
                          "mobileRightColumn": 62,
                          "mobileTopRow": 33,
                          "mobileBottomRow": 37,
                          "parentId": "6efm58tfjj",
                          "dynamicBindingPathList": [
                            {
                              "key": "buttonColor"
                            }
                          ],
                          "onClick": {
                            "label": "触发事件",
                            "name": "onClick",
                            "status": "add",
                            "children": [
                              {
                                "name": "block",
                                "type": "block",
                                "uid": "901764dbf32146e68b0b96f847e31b4f",
                                "children": [
                                  {
                                    "name": "action",
                                    "type": "action",
                                    "pid": "901764dbf32146e68b0b96f847e31b4f",
                                    "uid": "ba9ec7f46b574b6c8185a57bdd232067",
                                    "actionConfig": {
                                      "action": "post",
                                      "actionId": 412744702667696,
                                      "apiTarget": "061D10389001E1D4",
                                      "apiDescription": "新增数据",
                                      "linkageId": null,
                                      "linkageEvent": null,
                                      "modalName": null
                                    },
                                    "children": null
                                  },
                                  {
                                    "name": "success",
                                    "type": "success",
                                    "pid": "901764dbf32146e68b0b96f847e31b4f",
                                    "uid": "5fa1d6c82d864636acbd4f8514382cd2",
                                    "actionConfig": null,
                                    "children": [
                                      {
                                        "name": "block",
                                        "type": "block",
                                        "uid": "197a31f823464641a1656c554907be32",
                                        "children":   [
                                          {
                                            "name": "action",
                                            "type": "action",
                                            "pid": "197a31f823464641a1656c554907be32",
                                            "uid": "bba350fa5e92445fa08fdac49229e9ec",
                                            "actionConfig": {
                                              "action": "closeModal",
                                              "actionId": 412744702667706,
                                              "apiTarget": "061D10389001E1D4",
                                              "apiDescription": null,
                                              "linkageId": null,
                                              "linkageEvent": null,
                                              "modalName": "add_Modal"
                                            },
                                            "children": null
                                          },
                                          {
                                            "name": "success",
                                            "type": "success",
                                            "pid": "197a31f823464641a1656c554907be32",
                                            "uid": "244de12538c745719ec2118382de3bb3",
                                            "actionConfig": null,
                                            "children": null
                                          },
                                          {
                                            "name": "fail",
                                            "type": "fail",
                                            "pid": "197a31f823464641a1656c554907be32",
                                            "uid": "ebf3ff0d20b14c049ece2d4e6834297a",
                                            "actionConfig": null,
                                            "children": null
                                          }
                                        ]
                                      },
                                      {
                                        "name": "block",
                                        "type": "block",
                                        "uid": "8365bb48bdc2403f858270d8b4f6f456",
                                        "children": [
                                          {
                                            "name": "action",
                                            "type": "action",
                                            "pid": "8365bb48bdc2403f858270d8b4f6f456",
                                            "uid": "168a3d056fe740a69a821431ff7afb09",
                                            "actionConfig": {
                                              "action": "linkage",
                                              "actionId": 412744702667710,
                                              "apiTarget": "061D10389001E1D4",
                                              "apiDescription": null,
                                              "linkageId": "ph6z3iu55h",
                                              "linkageEvent": "onLoad",
                                              "modalName": null
                                            },
                                            "children": null
                                          },
                                          {
                                            "name": "success",
                                            "type": "success",
                                            "pid": "8365bb48bdc2403f858270d8b4f6f456",
                                            "uid": "d787fffd16b8416191e6a2a12ddc0bff",
                                            "actionConfig": null,
                                            "children": null
                                          },
                                          {
                                            "name": "fail",
                                            "type": "fail",
                                            "pid": "8365bb48bdc2403f858270d8b4f6f456",
                                            "uid": "724c5ee33b8641289d61f66ddf963849",
                                            "actionConfig": null,
                                            "children": null
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "name": "fail",
                                    "type": "fail",
                                    "pid": "901764dbf32146e68b0b96f847e31b4f",
                                    "uid": "7cf0b6941b7b4836ba6b96ebf7580389",
                                    "actionConfig": null,
                                    "children": null
                                  }
                                ]
                              }
                            ]
                          },
                          "dynamicTriggerPathList": [],
                          "originalTopRow": 154,
                          "originalBottomRow": 157
                        },
                        {
                          "isVisible": true,
                          "animateLoading": true,
                          "text": "取消",
                          "buttonVariant": "SECONDARY",
                          "placement": "CENTER",
                          "widgetName": "CreateCancelBtn",
                          "isDisabled": false,
                          "isDefaultClickDisabled": true,
                          "disabledWhenInvalid": false,
                          "resetFormOnClick": true,
                          "recaptchaType": "V3",
                          "version": 1,
                          "borderRadius": "0.375rem",
                          "responsiveBehavior": "hug",
                          "minWidth": 120,
                          "searchTags": [
                            "click",
                            "submit"
                          ],
                          "type": "BUTTON_WIDGET",
                          "hideCard": false,
                          "isDeprecated": false,
                          "displayName": "Button",
                          "key": "B24F221189449F24",
                          "iconSVG": "./static/media/icon.2075e59f4c855dc62f664870206244a0.svg",
                          "widgetId": "CD554FDEC501F9C6",
                          "renderMode": "CANVAS",
                          "buttonColor": "{{appsmith.theme.colors.primaryColor}}",
                          "boxShadow": "none",
                          "isLoading": false,
                          "leftColumn": 103,
                          "rightColumn": 114,
                          "topRow": 129,
                          "bottomRow": 132,
                          "mobileLeftColumn": 30,
                          "mobileRightColumn": 46,
                          "mobileTopRow": 33,
                          "mobileBottomRow": 37,
                          "parentId": "6efm58tfjj",
                          "dynamicBindingPathList": [
                            {
                              "key": "buttonColor"
                            }
                          ],
                          "onClick": {
                            "name": "onClick",
                            "status": "add",
                            "label": "触发事件",
                            "children": [
                              {
                                "name": "block",
                                "type": "block",
                                "uid": "38e816321c8a44a9ba24073450dc8055",
                                "children": [
                                  {
                                    "name": "action",
                                    "type": "action",
                                    "uid": "476fb05a864049059f37e938cc288a7d",
                                    "pid": "38e816321c8a44a9ba24073450dc8055",
                                    "actionConfig": {
                                      "action": "closeModal",
                                      "actionId": 178899498243116,
                                      "modalName": "add_Modal",
                                      "apiTarget": "tvr9wq843h"
                                    }
                                  },
                                  {
                                    "name": "success",
                                    "type": "success",
                                    "uid": "368f22a97efd40aeb191af204378a5ee",
                                    "pid": "38e816321c8a44a9ba24073450dc8055"
                                  },
                                  {
                                    "name": "fail",
                                    "type": "fail",
                                    "uid": "f94e7c1ff96d4f09b521f79874157e3a",
                                    "pid": "38e816321c8a44a9ba24073450dc8055"
                                  }
                                ]
                              }
                            ]
                          },
                          "dynamicTriggerPathList": [],
                          "originalTopRow": 154,
                          "originalBottomRow": 157
                        }
                      ],
                      "minHeight": 400,
                      "widgetId": "6efm58tfjj",
                      "renderMode": "CANVAS",
                      "isLoading": false,
                      "parentColumnSpace": 1,
                      "parentRowSpace": 1,
                      "leftColumn": 0,
                      "rightColumn": 145.6875,
                      "topRow": 0,
                      "bottomRow": 1340,
                      "mobileLeftColumn": 0,
                      "mobileRightColumn": 145.6875,
                      "mobileTopRow": 0,
                      "mobileBottomRow": 400,
                      "parentId": "yy4qk320wr",
                      "dynamicBindingPathList": []
                    }
                  ],
                  "positioning": "fixed",
                  "responsiveBehavior": "fill",
                  "minWidth": 450,
                  "minDynamicHeight": 10,
                  "maxDynamicHeight": 9000,
                  "dynamicHeight": "AUTO_HEIGHT",
                  "shouldScrollContents": true,
                  "searchTags": [
                    "group"
                  ],
                  "type": "FORM_WIDGET",
                  "hideCard": false,
                  "isDeprecated": false,
                  "displayName": "Form",
                  "key": "33j0xq3l6r",
                  "iconSVG": "./static/media/icon.5d6d2ac5cb1aa68bcd9b14f11c56b44a.svg",
                  "isCanvas": true,
                  "widgetId": "yy4qk320wr",
                  "renderMode": "CANVAS",
                  "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                  "boxShadow": "none",
                  "isLoading": false,
                  "parentColumnSpace": 6.9375,
                  "parentRowSpace": 10,
                  "leftColumn": 3,
                  "rightColumn": 125,
                  "topRow": 6,
                  "bottomRow": 140,
                  "mobileLeftColumn": 0,
                  "mobileRightColumn": 21,
                  "mobileTopRow": 25,
                  "mobileBottomRow": 65,
                  "parentId": "r6gkycc3fb",
                  "dynamicBindingPathList": [
                    {
                      "key": "borderRadius"
                    }
                  ],
                  "originalTopRow": 6,
                  "originalBottomRow": 165,
                  "dynamicTriggerPathList": []
                }
              ],
              "minHeight": 1610,
              "widgetId": "r6gkycc3fb",
              "renderMode": "CANVAS",
              "isLoading": false,
              "parentColumnSpace": 1,
              "parentRowSpace": 1,
              "leftColumn": 0,
              "rightColumn": 334.96875,
              "topRow": 0,
              "bottomRow": 1420,
              "mobileLeftColumn": 0,
              "mobileRightColumn": 334.96875,
              "mobileTopRow": 0,
              "mobileBottomRow": 240,
              "parentId": "zocl3n4jaa",
              "dynamicBindingPathList": []
            }
          ],
          "version": 2,
          "maxDynamicHeight": 9000,
          "dynamicHeight": "AUTO_HEIGHT",
          "searchTags": [
            "dialog",
            "popup",
            "notification"
          ],
          "type": "MODAL_WIDGET",
          "hideCard": false,
          "isDeprecated": false,
          "displayName": "Modal",
          "key": "5frlqanmhf",
          "iconSVG": "./static/media/icon.d2ab7de0666eaef853cc2d330f86887b.svg",
          "isCanvas": true,
          "widgetId": "zocl3n4jaa",
          "renderMode": "CANVAS",
          "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
          "boxShadow": "none",
          "isLoading": false,
          "parentColumnSpace": 13.95703125,
          "parentRowSpace": 10,
          "leftColumn": 6,
          "rightColumn": 30,
          "topRow": 11,
          "bottomRow": 142,
          "mobileLeftColumn": 6,
          "mobileRightColumn": 30,
          "mobileTopRow": 11,
          "mobileBottomRow": 35,
          "parentId": "0",
          "dynamicBindingPathList": [
            {
              "key": "borderRadius"
            }
          ],
          "minHeight": 1420
        },
        {
          "width": 956,
          "height": 1570,
          "minDynamicHeight": 24,
          "canEscapeKeyClose": true,
          "animateLoading": true,
          "detachFromLayout": true,
          "canOutsideClickClose": true,
          "shouldScrollContents": true,
          "widgetName": "edit_Modal",
          "children": [
            {
              "isVisible": true,
              "widgetName": "Canvas3Copy",
              "version": 1,
              "detachFromLayout": true,
              "flexLayers": [],
              "responsiveBehavior": "fill",
              "minWidth": 450,
              "type": "CANVAS_WIDGET",
              "hideCard": true,
              "isDeprecated": false,
              "displayName": "Canvas",
              "key": "ymn28jtkbi",
              "canExtend": true,
              "isDisabled": false,
              "shouldScrollContents": false,
              "children": [
                {
                  "isVisible": true,
                  "borderColor": "#E0DEDE",
                  "borderWidth": "0",
                  "animateLoading": true,
                  "widgetName": "edit_formCopy",
                  "backgroundColor": "#FFFFFF",
                  "children": [
                    {
                      "isVisible": true,
                      "widgetName": "Canvas4Copy",
                      "version": 1,
                      "detachFromLayout": true,
                      "flexLayers": [],
                      "responsiveBehavior": "fill",
                      "minWidth": 450,
                      "type": "CANVAS_WIDGET",
                      "hideCard": true,
                      "isDeprecated": false,
                      "displayName": "Canvas",
                      "key": "ymn28jtkbi",
                      "containerStyle": "none",
                      "canExtend": false,
                      "children": [
                        {
                          "isVisible": true,
                          "label": "布尔",
                          "defaultSwitchState": true,
                          "widgetName": "boolEditForm",
                          "alignWidget": "LEFT",
                          "labelPosition": "Top",
                          "version": 1,
                          "isDisabled": false,
                          "animateLoading": true,
                          "responsiveBehavior": "fill",
                          "labelWidth": 8,
                          "minDynamicHeight": 3,
                          "maxDynamicHeight": 9000,
                          "dynamicHeight": "AUTO_HEIGHT",
                          "searchTags": [
                            "boolean"
                          ],
                          "type": "SWITCH_WIDGET",
                          "hideCard": false,
                          "isDeprecated": false,
                          "displayName": "bool",
                          "key": "BE20FB89E7A2D045",
                          "iconSVG": "./static/media/icon.c77450c6a660d2ddf1b49f085348de1c.svg",
                          "widgetId": "FAF445683AF247E1",
                          "renderMode": "CANVAS",
                          "accentColor": "{{appsmith.theme.colors.primaryColor}}",
                          "boxShadow": "none",
                          "labelTextColor": "{{appsmith.theme.form.label.fontColor}}",
                          "labelTextSize": "{{appsmith.theme.form.label.fontSize}}",
                          "labelStyle": "{{appsmith.theme.form.label.fontStyle}}",
                          "isLoading": false,
                          "parentColumnSpace": 5.555419921875,
                          "parentRowSpace": 10,
                          "leftColumn": 2,
                          "rightColumn": 62,
                          "topRow": 1,
                          "bottomRow": 6,
                          "mobileLeftColumn": 3,
                          "mobileRightColumn": 15,
                          "mobileTopRow": 36,
                          "mobileBottomRow": 39,
                          "parentId": "7svn6rcwmd",
                          "dynamicBindingPathList": [
                            {
                              "key": "accentColor"
                            },
                            {
                              "key": "labelTextColor"
                            },
                            {
                              "key": "labelTextSize"
                            },
                            {
                              "key": "labelStyle"
                            }
                          ],
                          "originalTopRow": 23,
                          "originalBottomRow": 28,
                          "dynamicTriggerPathList": [],
                          "labelText": "布尔"
                        },
                        {
                          "isVisible": true,
                          "isDisabled": false,
                          "isReadonly": false,
                          "datePickerType": "DATE_PICKER",
                          "label": "日期时间",
                          "labelPosition": "Top",
                          "labelAlignment": "right",
                          "placeholderText": "请选择日期",
                          "labelWidth": 5,
                          "labelTextSize": "0.875rem",
                          "dateFormat": "YYYY-MM-DD",
                          "widgetName": "dateTimeEditForm",
                          "defaultDate": "",
                          "minDate": "1920-12-31",
                          "maxDate": "2121-12-31",
                          "version": 2,
                          "isRequired": false,
                          "closeOnSelection": true,
                          "shortcuts": false,
                          "firstDayOfWeek": 0,
                          "timePrecision": "None",
                          "animateLoading": true,
                          "responsiveBehavior": "fill",
                          "minWidth": 450,
                          "minDynamicHeight": 4,
                          "maxDynamicHeight": 9000,
                          "dynamicHeight": "AUTO_HEIGHT",
                          "searchTags": [
                            "calendar"
                          ],
                          "type": "DATE_PICKER_WIDGET2",
                          "hideCard": false,
                          "isDeprecated": false,
                          "displayName": "dateTime",
                          "key": "DA3BEDDEB3E2C756",
                          "iconSVG": "./static/media/icon.c8ac755fdc7a44c32deab2390f007005.svg",
                          "widgetId": "332D4599629A4323",
                          "renderMode": "CANVAS",
                          "accentColor": "{{appsmith.theme.colors.primaryColor}}",
                          "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                          "boxShadow": "none",
                          "isLoading": false,
                          "parentColumnSpace": 9.21875,
                          "parentRowSpace": 10,
                          "leftColumn": 66,
                          "rightColumn": 126,
                          "topRow": 1,
                          "bottomRow": 6,
                          "mobileLeftColumn": 1,
                          "mobileRightColumn": 21,
                          "mobileTopRow": 14,
                          "mobileBottomRow": 21,
                          "parentId": "7svn6rcwmd",
                          "dynamicBindingPathList": [
                            {
                              "key": "accentColor"
                            },
                            {
                              "key": "borderRadius"
                            }
                          ],
                          "originalTopRow": 15,
                          "originalBottomRow": 21,
                          "dynamicTriggerPathList": [],
                          "labelText": "日期时间"
                        },
                        {
                          "isVisible": true,
                          "placeholderText": "请选择",
                          "labelText": "选项",
                          "labelPosition": "Top",
                          "labelAlignment": "right",
                          "labelWidth": 8,
                          "selectId": 366465321725578,
                          "defaultOptions": [],
                          "serverSideFiltering": false,
                          "widgetName": "dictEditForm",
                          "defaultOptionValue": null,
                          "defaultOptionLabel": null,
                          "version": 1,
                          "isFilterable": true,
                          "isRequired": false,
                          "isDisabled": false,
                          "isReadonly": false,
                          "animateLoading": true,
                          "responsiveBehavior": "fill",
                          "minWidth": 375,
                          "minDynamicHeight": 3,
                          "maxDynamicHeight": 9000,
                          "dynamicHeight": "AUTO_HEIGHT",
                          "searchTags": [
                            "dropdown"
                          ],
                          "type": "SELECT_WIDGET",
                          "hideCard": false,
                          "isDeprecated": false,
                          "displayName": "dict",
                          "key": "F042EE07CDD92484",
                          "iconSVG": "./static/media/icon.1a5defb3c19b4cac4a27829d1f979e4c.svg",
                          "widgetId": "B06E7E1D94686515",
                          "renderMode": "CANVAS",
                          "accentColor": "{{appsmith.theme.colors.primaryColor}}",
                          "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                          "boxShadow": "{{appsmith.theme.boxShadow.appBoxShadow}}",
                          "it_color": "{{appsmith.theme.form.inputText.fontColor}}",
                          "it_size": "{{appsmith.theme.form.inputText.fontSize}}",
                          "it_style": "{{appsmith.theme.form.inputText.fontStyle}}",
                          "labelTextColor": "{{appsmith.theme.form.label.fontColor}}",
                          "labelTextSize": "{{appsmith.theme.form.label.fontSize}}",
                          "labelStyle": "{{appsmith.theme.form.label.fontStyle}}",
                          "ib_bgColor": "{{appsmith.theme.form.inputBorder.bgColor}}",
                          "ib_borderColor": "{{appsmith.theme.form.inputBorder.bgBorderColor}}",
                          "isLoading": false,
                          "parentColumnSpace": 5.555419921875,
                          "parentRowSpace": 10,
                          "leftColumn": 2,
                          "rightColumn": 62,
                          "topRow": 7,
                          "bottomRow": 13,
                          "mobileLeftColumn": 17,
                          "mobileRightColumn": 45,
                          "mobileTopRow": 10,
                          "mobileBottomRow": 13,
                          "parentId": "7svn6rcwmd",
                          "dynamicBindingPathList": [
                            {
                              "key": "accentColor"
                            },
                            {
                              "key": "borderRadius"
                            },
                            {
                              "key": "boxShadow"
                            },
                            {
                              "key": "it_color"
                            },
                            {
                              "key": "it_size"
                            },
                            {
                              "key": "it_style"
                            },
                            {
                              "key": "labelTextColor"
                            },
                            {
                              "key": "labelTextSize"
                            },
                            {
                              "key": "labelStyle"
                            },
                            {
                              "key": "ib_bgColor"
                            },
                            {
                              "key": "ib_borderColor"
                            }
                          ],
                          "dynamicTriggerPathList": [],
                          "originalTopRow": 8,
                          "originalBottomRow": 14,
                          "label": "选项",
                        },
                        {
                          "isVisible": true,
                          "label": "邮箱",
                          "labelPosition": "Top",
                          "labelAlignment": "right",
                          "labelWidth": 8,
                          "widgetName": "emailEditForm",
                          "version": 2,
                          "iconAlign": "left",
                          "autoFocus": false,
                          "resetOnSubmit": true,
                          "isRequired": false,
                          "isDisabled": false,
                          "readonly": false,
                          "animateLoading": true,
                          "responsiveBehavior": "fill",
                          "minWidth": 375,
                          "inputType": "EMAIL",
                          "showStepArrows": false,
                          "isCount": false,
                          "minDynamicHeight": 3,
                          "maxDynamicHeight": 9000,
                          "dynamicHeight": "AUTO_HEIGHT",
                          "searchTags": [
                            "form",
                            "text input",
                            "number",
                            "textarea"
                          ],
                          "type": "INPUT_WIDGET_V2",
                          "hideCard": false,
                          "isDeprecated": false,
                          "displayName": "email",
                          "key": "69AEA995566D4A0E",
                          "iconSVG": "./static/media/icon.d0ce957b6c4640f8a7418ce846ee200e.svg",
                          "widgetId": "8B7C50A36CEE6E30",
                          "renderMode": "CANVAS",
                          "accentColor": "{{appsmith.theme.colors.primaryColor}}",
                          "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                          "boxShadow": "{{appsmith.theme.boxShadow.appBoxShadow}}",
                          "it_color": "{{appsmith.theme.form.inputText.fontColor}}",
                          "it_size": "{{appsmith.theme.form.inputText.fontSize}}",
                          "it_style": "{{appsmith.theme.form.inputText.fontStyle}}",
                          "labelTextColor": "{{appsmith.theme.form.label.fontColor}}",
                          "labelTextSize": "{{appsmith.theme.form.label.fontSize}}",
                          "labelStyle": "{{appsmith.theme.form.label.fontStyle}}",
                          "ib_bgColor": "{{appsmith.theme.form.inputBorder.bgColor}}",
                          "ib_borderColor": "{{appsmith.theme.form.inputBorder.bgBorderColor}}",
                          "isLoading": false,
                          "parentColumnSpace": 8.503662109375,
                          "parentRowSpace": 10,
                          "leftColumn": 66,
                          "rightColumn": 126,
                          "topRow": 7,
                          "bottomRow": 13,
                          "mobileLeftColumn": 2,
                          "mobileRightColumn": 30,
                          "mobileTopRow": 148,
                          "mobileBottomRow": 151,
                          "parentId": "7svn6rcwmd",
                          "dynamicBindingPathList": [
                            {
                              "key": "accentColor"
                            },
                            {
                              "key": "borderRadius"
                            },
                            {
                              "key": "boxShadow"
                            },
                            {
                              "key": "it_color"
                            },
                            {
                              "key": "it_size"
                            },
                            {
                              "key": "it_style"
                            },
                            {
                              "key": "labelTextColor"
                            },
                            {
                              "key": "labelTextSize"
                            },
                            {
                              "key": "labelStyle"
                            },
                            {
                              "key": "ib_bgColor"
                            },
                            {
                              "key": "ib_borderColor"
                            }
                          ],
                          "dynamicTriggerPathList": [],
                          "shouldAllowAutofill": true,
                          "originalTopRow": 30,
                          "originalBottomRow": 36,
                          "labelText": "邮箱"
                        },
                        {
                          "isVisible": true,
                          "defaultImage": "https://assets.appsmith.com/widgets/default.png",
                          "imageShape": "RECTANGLE",
                          "maxZoomLevel": 1,
                          "enableRotation": false,
                          "enableDownload": false,
                          "objectFit": "cover",
                          "image": "",
                          "widgetName": "fileEditForm",
                          "version": 1,
                          "animateLoading": true,
                          "value": "[]",
                          "label": "文件",
                          "labelPosition": "Top",
                          "labelWidth": 8,
                          "accept": "",
                          "fileSize": 10,
                          "fileCount": 1,
                          "disabled": false,
                          "labelAlignment": "right",
                          "btnText": "点击上传文件",
                          "defaultValue": "[]",
                          "minDynamicHeight": 3,
                          "maxDynamicHeight": 9000,
                          "dynamicHeight": "AUTO_HEIGHT",
                          "type": "UPLOAD_WIDGET",
                          "hideCard": false,
                          "isDeprecated": false,
                          "displayName": "file",
                          "key": "ADBA0A0BAFCE0B3B",
                          "iconSVG": "./static/media/icon.2c8bfbc118a7a5f7b61b10540a4a8881.svg",
                          "widgetId": "415D67854150754E",
                          "renderMode": "CANVAS",
                          "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                          "boxShadow": "{{appsmith.theme.boxShadow.appBoxShadow}}",
                          "accentColor": "{{appsmith.theme.colors.primaryColor}}",
                          "labelTextColor": "{{appsmith.theme.form.label.fontColor}}",
                          "labelTextSize": "{{appsmith.theme.form.label.fontSize}}",
                          "labelStyle": "{{appsmith.theme.form.label.fontStyle}}",
                          "isLoading": false,
                          "parentColumnSpace": 5.555419921875,
                          "parentRowSpace": 10,
                          "leftColumn": 2,
                          "rightColumn": 126,
                          "topRow": 14,
                          "bottomRow": 21,
                          "mobileLeftColumn": 3,
                          "mobileRightColumn": 33,
                          "mobileTopRow": 57,
                          "mobileBottomRow": 60,
                          "parentId": "7svn6rcwmd",
                          "dynamicBindingPathList": [
                            {
                              "key": "borderRadius"
                            },
                            {
                              "key": "boxShadow"
                            },
                            {
                              "key": "accentColor"
                            },
                            {
                              "key": "labelTextColor"
                            },
                            {
                              "key": "labelTextSize"
                            },
                            {
                              "key": "labelStyle"
                            }
                          ],
                          "originalTopRow": 45,
                          "originalBottomRow": 52,
                          "dynamicTriggerPathList": [],
                          "labelText": "文件"
                        },
                        {
                          "isVisible": true,
                          "label": "小数",
                          "labelPosition": "Top",
                          "labelAlignment": "right",
                          "labelWidth": 8,
                          "widgetName": "floatEditForm",
                          "version": 2,
                          "iconAlign": "left",
                          "autoFocus": false,
                          "resetOnSubmit": true,
                          "isRequired": false,
                          "isDisabled": false,
                          "readonly": false,
                          "animateLoading": true,
                          "responsiveBehavior": "fill",
                          "minWidth": 375,
                          "inputType": "NUMBER",
                          "showStepArrows": false,
                          "isCount": false,
                          "minDynamicHeight": 3,
                          "maxDynamicHeight": 9000,
                          "dynamicHeight": "AUTO_HEIGHT",
                          "searchTags": [
                            "form",
                            "text input",
                            "number",
                            "textarea"
                          ],
                          "type": "INPUT_WIDGET_V2",
                          "hideCard": false,
                          "isDeprecated": false,
                          "displayName": "float",
                          "key": "752CD8123DAEFC85",
                          "iconSVG": "/static/media/icon.d0ce957b6c4640f8a7418ce846ee200e.svg",
                          "widgetId": "9CDB57BEA42587DF",
                          "renderMode": "CANVAS",
                          "accentColor": "{{appsmith.theme.colors.primaryColor}}",
                          "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                          "boxShadow": "{{appsmith.theme.boxShadow.appBoxShadow}}",
                          "it_color": "{{appsmith.theme.form.inputText.fontColor}}",
                          "it_size": "{{appsmith.theme.form.inputText.fontSize}}",
                          "it_style": "{{appsmith.theme.form.inputText.fontStyle}}",
                          "labelTextColor": "{{appsmith.theme.form.label.fontColor}}",
                          "labelTextSize": "{{appsmith.theme.form.label.fontSize}}",
                          "labelStyle": "{{appsmith.theme.form.label.fontStyle}}",
                          "ib_bgColor": "{{appsmith.theme.form.inputBorder.bgColor}}",
                          "ib_borderColor": "{{appsmith.theme.form.inputBorder.bgBorderColor}}",
                          "isLoading": false,
                          "parentColumnSpace": 8.503662109375,
                          "parentRowSpace": 10,
                          "leftColumn": 2,
                          "rightColumn": 62,
                          "topRow": 22,
                          "bottomRow": 28,
                          "mobileLeftColumn": 2,
                          "mobileRightColumn": 30,
                          "mobileTopRow": 57,
                          "mobileBottomRow": 60,
                          "parentId": "7svn6rcwmd",
                          "dynamicBindingPathList": [
                            {
                              "key": "accentColor"
                            },
                            {
                              "key": "borderRadius"
                            },
                            {
                              "key": "boxShadow"
                            },
                            {
                              "key": "it_color"
                            },
                            {
                              "key": "it_size"
                            },
                            {
                              "key": "it_style"
                            },
                            {
                              "key": "labelTextColor"
                            },
                            {
                              "key": "labelTextSize"
                            },
                            {
                              "key": "labelStyle"
                            },
                            {
                              "key": "ib_bgColor"
                            },
                            {
                              "key": "ib_borderColor"
                            }
                          ],
                          "dynamicTriggerPathList": [],
                          "originalTopRow": 38,
                          "originalBottomRow": 44,
                          "shouldAllowAutofill": false,
                          "labelText": "小数"
                        },
                        {
                          "isVisible": true,
                          "dynamicHeight": "AUTO_HEIGHT",
                          "defaultImage": "https://assets.appsmith.com/widgets/default.png",
                          "imageShape": "RECTANGLE",
                          "maxZoomLevel": 1,
                          "enableRotation": false,
                          "enableDownload": false,
                          "objectFit": "cover",
                          "image": "",
                          "widgetName": "imageEditForm",
                          "version": 1,
                          "animateLoading": true,
                          "value": "[]",
                          "label": "图片",
                          "labelPosition": "Top",
                          "labelWidth": 8,
                          "fileSize": 10,
                          "fileCount": 1,
                          "disabled": false,
                          "labelAlignment": "right",
                          "btnText": "上传",
                          "accept": ".jpg,.jpeg,.png",
                          "defaultValue": "[]",
                          "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                          "type": "UPLOAD_IMAGE_WIDGET",
                          "hideCard": false,
                          "isDeprecated": false,
                          "displayName": "image",
                          "key": "EA22DDF83491FFF7",
                          "iconSVG": "./static/media/icon.30c8cbd442cce232b01ba2d434c53a53.svg",
                          "widgetId": "FDFD6FC774E4AB58",
                          "renderMode": "CANVAS",
                          "boxShadow": "{{appsmith.theme.boxShadow.appBoxShadow}}",
                          "accentColor": "{{appsmith.theme.colors.primaryColor}}",
                          "labelTextColor": "{{appsmith.theme.form.label.fontColor}}",
                          "labelTextSize": "{{appsmith.theme.form.label.fontSize}}",
                          "labelStyle": "{{appsmith.theme.form.label.fontStyle}}",
                          "isLoading": false,
                          "parentColumnSpace": 7.11865234375,
                          "parentRowSpace": 10,
                          "leftColumn": 2,
                          "rightColumn": 127,
                          "topRow": 29,
                          "bottomRow": 42,
                          "mobileLeftColumn": 3,
                          "mobileRightColumn": 29,
                          "mobileTopRow": 64,
                          "mobileBottomRow": 73,
                          "parentId": "7svn6rcwmd",
                          "dynamicBindingPathList": [
                            {
                              "key": "borderRadius"
                            },
                            {
                              "key": "boxShadow"
                            },
                            {
                              "key": "accentColor"
                            },
                            {
                              "key": "labelTextColor"
                            },
                            {
                              "key": "labelTextSize"
                            },
                            {
                              "key": "labelStyle"
                            }
                          ],
                          "originalTopRow": 53,
                          "originalBottomRow": 66,
                          "dynamicTriggerPathList": [],
                          "labelText": "图片"
                        },
                        {
                          "isVisible": true,
                          "defaultImage": "https://assets.appsmith.com/widgets/default.png",
                          "imageShape": "RECTANGLE",
                          "maxZoomLevel": 1,
                          "enableRotation": false,
                          "enableDownload": false,
                          "objectFit": "cover",
                          "image": "",
                          "widgetName": "intEditForm",
                          "version": 1,
                          "animateLoading": true,
                          "value": "100",
                          "showTime": false,
                          "placeholderText1": "请选择开始日期",
                          "placeholderText2": "请选择结束日期",
                          "labelText": "整数",
                          "labelPosition": "Top",
                          "labelAlignment": "right",
                          "labelWidth": 8,
                          "Min": 0,
                          "Max": 9999,
                          "defaultValue": 100,
                          "readOnly": false,
                          "stringMode": false,
                          "minDynamicHeight": 3,
                          "maxDynamicHeight": 9000,
                          "dynamicHeight": "AUTO_HEIGHT",
                          "type": "INPUTNUMBER_WIDGET",
                          "hideCard": false,
                          "isDeprecated": false,
                          "displayName": "int",
                          "key": "A9515EE7325D69C8",
                          "iconSVG": "./static/media/icon.7824b9f0c785293524b78ae91a727700.svg",
                          "widgetId": "F6900A589EECED0C",
                          "renderMode": "CANVAS",
                          "accentColor": "{{appsmith.theme.colors.primaryColor}}",
                          "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                          "boxShadow": "{{appsmith.theme.boxShadow.appBoxShadow}}",
                          "it_color": "{{appsmith.theme.form.inputText.fontColor}}",
                          "it_size": "{{appsmith.theme.form.inputText.fontSize}}",
                          "it_style": "{{appsmith.theme.form.inputText.fontStyle}}",
                          "labelTextColor": "{{appsmith.theme.form.label.fontColor}}",
                          "labelTextSize": "{{appsmith.theme.form.label.fontSize}}",
                          "labelStyle": "{{appsmith.theme.form.label.fontStyle}}",
                          "ib_bgColor": "{{appsmith.theme.form.inputBorder.bgColor}}",
                          "ib_borderColor": "{{appsmith.theme.form.inputBorder.bgBorderColor}}",
                          "isLoading": false,
                          "parentColumnSpace": 5.555419921875,
                          "parentRowSpace": 10,
                          "leftColumn": 2,
                          "rightColumn": 62,
                          "topRow": 43,
                          "bottomRow": 49,
                          "mobileLeftColumn": 3,
                          "mobileRightColumn": 31,
                          "mobileTopRow": 42,
                          "mobileBottomRow": 45,
                          "parentId": "7svn6rcwmd",
                          "dynamicBindingPathList": [
                            {
                              "key": "accentColor"
                            },
                            {
                              "key": "borderRadius"
                            },
                            {
                              "key": "boxShadow"
                            },
                            {
                              "key": "it_color"
                            },
                            {
                              "key": "it_size"
                            },
                            {
                              "key": "it_style"
                            },
                            {
                              "key": "labelTextColor"
                            },
                            {
                              "key": "labelTextSize"
                            },
                            {
                              "key": "labelStyle"
                            },
                            {
                              "key": "ib_bgColor"
                            },
                            {
                              "key": "ib_borderColor"
                            }
                          ],
                          "dynamicTriggerPathList": [],
                          "originalTopRow": 22,
                          "originalBottomRow": 28,
                          "shouldScrollContents": true,
                          "label": "整数"
                        },
                        {
                          "isVisible": true,
                          "label": "单行文本",
                          "labelPosition": "Top",
                          "labelAlignment": "right",
                          "labelTextSize": "0.875rem",
                          "labelWidth": "10",
                          "widgetName": "lineTextEditForm",
                          "version": 2,
                          "defaultText": "",
                          "iconAlign": "left",
                          "autoFocus": false,
                          "labelStyle": "",
                          "resetOnSubmit": true,
                          "isRequired": true,
                          "isDisabled": false,
                          "readonly": false,
                          "animateLoading": true,
                          "responsiveBehavior": "fill",
                          "minWidth": 450,
                          "inputType": "TEXT",
                          "showStepArrows": false,
                          "isCount": false,
                          "minDynamicHeight": 4,
                          "maxDynamicHeight": 9000,
                          "dynamicHeight": "AUTO_HEIGHT",
                          "searchTags": [
                            "form",
                            "text input",
                            "number",
                            "textarea"
                          ],
                          "type": "INPUT_WIDGET_V2",
                          "hideCard": false,
                          "isDeprecated": false,
                          "displayName": "lineText",
                          "key": "859B5644AE0B6389",
                          "iconSVG": "./static/media/icon.d0ce957b6c4640f8a7418ce846ee200e.svg",
                          "widgetId": "C87DD1E16C923DF9",
                          "renderMode": "CANVAS",
                          "accentColor": "{{appsmith.theme.colors.primaryColor}}",
                          "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                          "boxShadow": "none",
                          "isLoading": false,
                          "parentColumnSpace": 6.9375,
                          "parentRowSpace": 10,
                          "leftColumn": 66,
                          "rightColumn": 126,
                          "topRow": 43,
                          "bottomRow": 49,
                          "mobileLeftColumn": 1,
                          "mobileRightColumn": 21,
                          "mobileTopRow": 6,
                          "mobileBottomRow": 13,
                          "parentId": "7svn6rcwmd",
                          "dynamicBindingPathList": [
                            {
                              "key": "accentColor"
                            },
                            {
                              "key": "borderRadius"
                            }
                          ],
                          "originalTopRow": 1,
                          "originalBottomRow": 7,
                          "dynamicTriggerPathList": [],
                          "labelText": "单行文本"
                        },
                        {
                          "isVisible": true,
                          "defaultImage": "https://assets.appsmith.com/widgets/default.png",
                          "imageShape": "RECTANGLE",
                          "maxZoomLevel": 1,
                          "enableRotation": false,
                          "enableDownload": false,
                          "objectFit": "cover",
                          "image": "",
                          "widgetName": "longIntEditForm",
                          "version": 1,
                          "animateLoading": true,
                          "value": "100",
                          "showTime": false,
                          "placeholderText1": "请选择开始日期",
                          "placeholderText2": "请选择结束日期",
                          "labelText": "长整数",
                          "labelPosition": "Top",
                          "labelAlignment": "right",
                          "labelWidth": 8,
                          "Min": 0,
                          "Max": 9999,
                          "defaultValue": 100,
                          "readOnly": false,
                          "stringMode": false,
                          "minDynamicHeight": 3,
                          "maxDynamicHeight": 9000,
                          "dynamicHeight": "AUTO_HEIGHT",
                          "type": "INPUTNUMBER_WIDGET",
                          "hideCard": false,
                          "isDeprecated": false,
                          "displayName": "longInt",
                          "key": "6EAF52ECA26290AC",
                          "iconSVG": "./static/media/icon.7824b9f0c785293524b78ae91a727700.svg",
                          "widgetId": "D19223E52C8ADF05",
                          "renderMode": "CANVAS",
                          "accentColor": "{{appsmith.theme.colors.primaryColor}}",
                          "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                          "boxShadow": "{{appsmith.theme.boxShadow.appBoxShadow}}",
                          "it_color": "{{appsmith.theme.form.inputText.fontColor}}",
                          "it_size": "{{appsmith.theme.form.inputText.fontSize}}",
                          "it_style": "{{appsmith.theme.form.inputText.fontStyle}}",
                          "labelTextColor": "{{appsmith.theme.form.label.fontColor}}",
                          "labelTextSize": "{{appsmith.theme.form.label.fontSize}}",
                          "labelStyle": "{{appsmith.theme.form.label.fontStyle}}",
                          "ib_bgColor": "{{appsmith.theme.form.inputBorder.bgColor}}",
                          "ib_borderColor": "{{appsmith.theme.form.inputBorder.bgBorderColor}}",
                          "isLoading": false,
                          "parentColumnSpace": 5.555419921875,
                          "parentRowSpace": 10,
                          "leftColumn": 2,
                          "rightColumn": 62,
                          "topRow": 50,
                          "bottomRow": 56,
                          "mobileLeftColumn": 3,
                          "mobileRightColumn": 31,
                          "mobileTopRow": 42,
                          "mobileBottomRow": 45,
                          "parentId": "7svn6rcwmd",
                          "dynamicBindingPathList": [
                            {
                              "key": "accentColor"
                            },
                            {
                              "key": "borderRadius"
                            },
                            {
                              "key": "boxShadow"
                            },
                            {
                              "key": "it_color"
                            },
                            {
                              "key": "it_size"
                            },
                            {
                              "key": "it_style"
                            },
                            {
                              "key": "labelTextColor"
                            },
                            {
                              "key": "labelTextSize"
                            },
                            {
                              "key": "labelStyle"
                            },
                            {
                              "key": "ib_bgColor"
                            },
                            {
                              "key": "ib_borderColor"
                            }
                          ],
                          "dynamicTriggerPathList": [],
                          "originalTopRow": 22,
                          "originalBottomRow": 28,
                          "shouldScrollContents": true,
                          "label": "长整数"
                        },
                        {
                          "isVisible": true,
                          "label": "多行文本",
                          "labelPosition": "Top",
                          "labelAlignment": "right",
                          "labelWidth": 8,
                          "widgetName": "moreLineTextEditForm",
                          "version": 2,
                          "iconAlign": "left",
                          "autoFocus": false,
                          "resetOnSubmit": true,
                          "isRequired": false,
                          "isDisabled": false,
                          "readonly": false,
                          "animateLoading": true,
                          "responsiveBehavior": "fill",
                          "minWidth": 375,
                          "inputType": "MULTI_LINE_TEXT",
                          "showStepArrows": false,
                          "isCount": false,
                          "minDynamicHeight": 3,
                          "maxDynamicHeight": 9000,
                          "dynamicHeight": "AUTO_HEIGHT",
                          "searchTags": [
                            "form",
                            "text input",
                            "number",
                            "textarea"
                          ],
                          "type": "INPUT_WIDGET_V2",
                          "hideCard": false,
                          "isDeprecated": false,
                          "displayName": "moreLineText",
                          "key": "8CB8182AB8EC2BDD",
                          "iconSVG": "./static/media/icon.d0ce957b6c4640f8a7418ce846ee200e.svg",
                          "widgetId": "A664A14B4BB79471",
                          "renderMode": "CANVAS",
                          "accentColor": "{{appsmith.theme.colors.primaryColor}}",
                          "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                          "boxShadow": "{{appsmith.theme.boxShadow.appBoxShadow}}",
                          "it_color": "{{appsmith.theme.form.inputText.fontColor}}",
                          "it_size": "{{appsmith.theme.form.inputText.fontSize}}",
                          "it_style": "{{appsmith.theme.form.inputText.fontStyle}}",
                          "labelTextColor": "{{appsmith.theme.form.label.fontColor}}",
                          "labelTextSize": "{{appsmith.theme.form.label.fontSize}}",
                          "labelStyle": "{{appsmith.theme.form.label.fontStyle}}",
                          "ib_bgColor": "{{appsmith.theme.form.inputBorder.bgColor}}",
                          "ib_borderColor": "{{appsmith.theme.form.inputBorder.bgBorderColor}}",
                          "isLoading": false,
                          "parentColumnSpace": 8.503662109375,
                          "parentRowSpace": 10,
                          "leftColumn": 66,
                          "rightColumn": 126,
                          "topRow": 50,
                          "bottomRow": 56,
                          "mobileLeftColumn": 67,
                          "mobileRightColumn": 95,
                          "mobileTopRow": 46,
                          "mobileBottomRow": 49,
                          "parentId": "7svn6rcwmd",
                          "dynamicBindingPathList": [
                            {
                              "key": "accentColor"
                            },
                            {
                              "key": "borderRadius"
                            },
                            {
                              "key": "boxShadow"
                            },
                            {
                              "key": "it_color"
                            },
                            {
                              "key": "it_size"
                            },
                            {
                              "key": "it_style"
                            },
                            {
                              "key": "labelTextColor"
                            },
                            {
                              "key": "labelTextSize"
                            },
                            {
                              "key": "labelStyle"
                            },
                            {
                              "key": "ib_bgColor"
                            },
                            {
                              "key": "ib_borderColor"
                            }
                          ],
                          "dynamicTriggerPathList": [],
                          "originalTopRow": 30,
                          "originalBottomRow": 39,
                          "shouldAllowAutofill": false,
                          "labelText": "多行文本"
                        },
                        {
                          "isVisible": true,
                          "defaultValue": "佰易开低代码开发平台",
                          "value": "",
                          "animateLoading": true,
                          "isDisabled": false,
                          "isReadonly": false,
                          "isRequired": false,
                          "widgetName": "richTextEditForm",
                          "isDefaultClickDisabled": true,
                          "inputType": "html",
                          "labelText": "富文本",
                          "labelPosition": "Top",
                          "labelAlignment": "right",
                          "labelWidth": 8,
                          "borderWidth": 1,
                          "borderColor": "{{appsmith.theme.form.inputBorder.bgBorderColor}}",
                          "version": 1,
                          "responsiveBehavior": "fill",
                          "minWidth": 375,
                          "backgroundColor": "#fff",
                          "minDynamicHeight": 3,
                          "maxDynamicHeight": 9000,
                          "dynamicHeight": "FIXED",
                          "searchTags": [
                            "input",
                            "rte"
                          ],
                          "type": "RICH_TEXT_EDITOR_WIDGET",
                          "hideCard": false,
                          "isDeprecated": false,
                          "displayName": "richText",
                          "key": "C872017A0D39C5A9",
                          "iconSVG": "./static/media/icon.cbb4ba403a42ccddcd5d4bb23ae7b4c9.svg",
                          "widgetId": "8B4F965FA37AE0E1",
                          "renderMode": "CANVAS",
                          "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                          "boxShadow": "{{appsmith.theme.boxShadow.appBoxShadow}}",
                          "labelTextColor": "{{appsmith.theme.form.label.fontColor}}",
                          "labelTextSize": "{{appsmith.theme.form.label.fontSize}}",
                          "labelStyle": "{{appsmith.theme.form.label.fontStyle}}",
                          "fontColor": "{{appsmith.theme.form.inputText.fontColor}}",
                          "ib_bgColor": "{{appsmith.theme.form.inputBorder.bgColor}}",
                          "isLoading": false,
                          "parentColumnSpace": 7.11865234375,
                          "parentRowSpace": 10,
                          "leftColumn": 2,
                          "rightColumn": 128,
                          "topRow": 57,
                          "bottomRow": 99,
                          "mobileLeftColumn": 2,
                          "mobileRightColumn": 82,
                          "mobileTopRow": 68,
                          "mobileBottomRow": 114,
                          "parentId": "7svn6rcwmd",
                          "dynamicBindingPathList": [
                            {
                              "key": "borderRadius"
                            },
                            {
                              "key": "boxShadow"
                            },
                            {
                              "key": "labelTextColor"
                            },
                            {
                              "key": "labelTextSize"
                            },
                            {
                              "key": "labelStyle"
                            },
                            {
                              "key": "fontColor"
                            },
                            {
                              "key": "ib_bgColor"
                            },
                            {
                              "key": "borderColor"
                            }
                          ],
                          "dynamicTriggerPathList": [],
                          "label": "富文本"
                        },
                        {
                          "isVisible": true,
                          "rowSpan": 1,
                          "widgetName": "childrenEditFormSubTable",
                          "version": 1,
                          "animateLoading": true,
                          "value": [],
                          "defaultValue": [],
                          "label": "children",
                          "labelPosition": "Top",
                          "labelWidth": 8,
                          "vertical": false,
                          "labelAlignment": "right",
                          "isDisabled": false,
                          "tableColumns": {},
                          "fixTableColumns": {
                            "id": {
                              "id": "id",
                              "index": 0,
                              "label": "id",
                              "columnType": "text"
                            },
                            "action": {
                              "id": "_subTable_action",
                              "index": 1,
                              "label": "增删改标记",
                              "columnType": "text"
                            }
                          },
                          "minDynamicHeight": 3,
                          "maxDynamicHeight": 9000,
                          "dynamicHeight": "AUTO_HEIGHT",
                          "type": "SUB_TABLE_WIDGET",
                          "hideCard": false,
                          "isDeprecated": false,
                          "displayName": "children",
                          "key": "4EF1489248D46DBF",
                          "iconSVG": "./static/media/icon.24905525921dd6f5ff46d0dd843b9e12.svg",
                          "widgetId": "2E06B22819E5825B",
                          "renderMode": "CANVAS",
                          "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                          "boxShadow": "{{appsmith.theme.boxShadow.appBoxShadow}}",
                          "labelTextColor": "{{appsmith.theme.form.label.fontColor}}",
                          "labelTextSize": "{{appsmith.theme.form.label.fontSize}}",
                          "labelStyle": "{{appsmith.theme.form.label.fontStyle}}",
                          "accentColor": "{{appsmith.theme.colors.primaryColor}}",
                          "opBtnBgColor": "{{appsmith.theme.colors.primaryColor}}",
                          "opBtnColor": "{{appsmith.theme.colors.primaryColor}}",
                          "newBtnColor": "{{appsmith.theme.colors.primaryColor}}",
                          "newBtnBgColor": "{{appsmith.theme.colors.primaryColor}}",
                          "opBtnType": "SECONDARY",
                          "newBtnType": "TERTIARY",
                          "isLoading": false,
                          "parentColumnSpace": 5.555419921875,
                          "parentRowSpace": 10,
                          "leftColumn": 2,
                          "rightColumn": 126,
                          "topRow": 100,
                          "bottomRow": 131,
                          "mobileLeftColumn": 2,
                          "mobileRightColumn": 62,
                          "mobileTopRow": 77,
                          "mobileBottomRow": 101,
                          "parentId": "7svn6rcwmd",
                          "dynamicBindingPathList": [
                            {
                              "key": "borderRadius"
                            },
                            {
                              "key": "boxShadow"
                            },
                            {
                              "key": "labelTextColor"
                            },
                            {
                              "key": "labelTextSize"
                            },
                            {
                              "key": "labelStyle"
                            },
                            {
                              "key": "accentColor"
                            },
                            {
                              "key": "opBtnBgColor"
                            },
                            {
                              "key": "opBtnColor"
                            },
                            {
                              "key": "newBtnColor"
                            },
                            {
                              "key": "newBtnBgColor"
                            }
                          ],
                          "originalTopRow": 119,
                          "originalBottomRow": 150,
                          "dynamicTriggerPathList": [],
                          "labelText": "children"
                        },
                        {
                          "isVisible": true,
                          "placeholderText": "请选择",
                          "labelText": "parentMainId",
                          "labelPosition": "Top",
                          "labelAlignment": "right",
                          "labelWidth": 8,
                          "selectId": null,
                          "defaultOptions": [],
                          "serverSideFiltering": false,
                          "widgetName": "parentMainIdEditForm",
                          "defaultOptionValue": null,
                          "defaultOptionLabel": null,
                          "version": 1,
                          "isFilterable": true,
                          "isRequired": false,
                          "isDisabled": false,
                          "isReadonly": false,
                          "animateLoading": true,
                          "responsiveBehavior": "fill",
                          "minWidth": 375,
                          "minDynamicHeight": 3,
                          "maxDynamicHeight": 9000,
                          "dynamicHeight": "AUTO_HEIGHT",
                          "searchTags": [
                            "dropdown"
                          ],
                          "type": "SELECT_WIDGET",
                          "hideCard": false,
                          "isDeprecated": false,
                          "displayName": "parentMainId",
                          "key": "859EA5CC49486126",
                          "iconSVG": "./static/media/icon.1a5defb3c19b4cac4a27829d1f979e4c.svg",
                          "widgetId": "B4B03EDC9F8A6C30",
                          "renderMode": "CANVAS",
                          "accentColor": "{{appsmith.theme.colors.primaryColor}}",
                          "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                          "boxShadow": "{{appsmith.theme.boxShadow.appBoxShadow}}",
                          "it_color": "{{appsmith.theme.form.inputText.fontColor}}",
                          "it_size": "{{appsmith.theme.form.inputText.fontSize}}",
                          "it_style": "{{appsmith.theme.form.inputText.fontStyle}}",
                          "labelTextColor": "{{appsmith.theme.form.label.fontColor}}",
                          "labelTextSize": "{{appsmith.theme.form.label.fontSize}}",
                          "labelStyle": "{{appsmith.theme.form.label.fontStyle}}",
                          "ib_bgColor": "{{appsmith.theme.form.inputBorder.bgColor}}",
                          "ib_borderColor": "{{appsmith.theme.form.inputBorder.bgBorderColor}}",
                          "isLoading": false,
                          "parentColumnSpace": 5.555419921875,
                          "parentRowSpace": 10,
                          "leftColumn": 2,
                          "rightColumn": 62,
                          "topRow": 132,
                          "bottomRow": 138,
                          "mobileLeftColumn": 17,
                          "mobileRightColumn": 45,
                          "mobileTopRow": 10,
                          "mobileBottomRow": 13,
                          "parentId": "7svn6rcwmd",
                          "dynamicBindingPathList": [
                            {
                              "key": "accentColor"
                            },
                            {
                              "key": "borderRadius"
                            },
                            {
                              "key": "boxShadow"
                            },
                            {
                              "key": "it_color"
                            },
                            {
                              "key": "it_size"
                            },
                            {
                              "key": "it_style"
                            },
                            {
                              "key": "labelTextColor"
                            },
                            {
                              "key": "labelTextSize"
                            },
                            {
                              "key": "labelStyle"
                            },
                            {
                              "key": "ib_bgColor"
                            },
                            {
                              "key": "ib_borderColor"
                            }
                          ],
                          "dynamicTriggerPathList": [],
                          "originalTopRow": 8,
                          "originalBottomRow": 14,
                          "label": "parentMainId",
                        },
                        {
                          "isVisible": true,
                          "animateLoading": true,
                          "text": "提交",
                          "buttonVariant": "PRIMARY",
                          "placement": "CENTER",
                          "widgetName": "UpdateBtn",
                          "isDisabled": false,
                          "isDefaultClickDisabled": true,
                          "disabledWhenInvalid": true,
                          "resetFormOnClick": false,
                          "recaptchaType": "V3",
                          "version": 1,
                          "borderRadius": "0.375rem",
                          "responsiveBehavior": "hug",
                          "minWidth": 120,
                          "searchTags": [
                            "click",
                            "submit"
                          ],
                          "type": "BUTTON_WIDGET",
                          "hideCard": false,
                          "isDeprecated": false,
                          "displayName": "Button",
                          "key": "3BC78B53102CFE81",
                          "iconSVG": "./static/media/icon.2075e59f4c855dc62f664870206244a0.svg",
                          "widgetId": "CEB2C50DB5BDBD55",
                          "renderMode": "CANVAS",
                          "buttonColor": "{{appsmith.theme.colors.primaryColor}}",
                          "boxShadow": "none",
                          "isLoading": false,
                          "leftColumn": 117,
                          "rightColumn": 128,
                          "topRow": 143,
                          "bottomRow": 146,
                          "mobileLeftColumn": 46,
                          "mobileRightColumn": 62,
                          "mobileTopRow": 33,
                          "mobileBottomRow": 37,
                          "parentId": "7svn6rcwmd",
                          "dynamicBindingPathList": [
                            {
                              "key": "buttonColor"
                            }
                          ],
                          "dynamicTriggerPathList": [],
                          "originalTopRow": 152,
                          "originalBottomRow": 155,
                        },
                        {
                          "isVisible": true,
                          "animateLoading": true,
                          "text": "取消",
                          "buttonVariant": "SECONDARY",
                          "placement": "CENTER",
                          "widgetName": "UpdateCancelBtn",
                          "isDisabled": false,
                          "isDefaultClickDisabled": true,
                          "disabledWhenInvalid": false,
                          "resetFormOnClick": true,
                          "recaptchaType": "V3",
                          "version": 1,
                          "borderRadius": "0.375rem",
                          "responsiveBehavior": "hug",
                          "minWidth": 120,
                          "searchTags": [
                            "click",
                            "submit"
                          ],
                          "type": "BUTTON_WIDGET",
                          "hideCard": false,
                          "isDeprecated": false,
                          "displayName": "Button",
                          "key": "32901D8EC21F0D09",
                          "iconSVG": "./static/media/icon.2075e59f4c855dc62f664870206244a0.svg",
                          "widgetId": "BFEC29192F95FD95",
                          "renderMode": "CANVAS",
                          "buttonColor": "{{appsmith.theme.colors.primaryColor}}",
                          "boxShadow": "none",
                          "isLoading": false,
                          "leftColumn": 105,
                          "rightColumn": 116,
                          "topRow": 143,
                          "bottomRow": 146,
                          "mobileLeftColumn": 30,
                          "mobileRightColumn": 46,
                          "mobileTopRow": 33,
                          "mobileBottomRow": 37,
                          "parentId": "7svn6rcwmd",
                          "dynamicBindingPathList": [
                            {
                              "key": "buttonColor"
                            }
                          ],
                          "dynamicTriggerPathList": [],
                          "originalTopRow": 152,
                          "originalBottomRow": 155
                        }
                      ],
                      "minHeight": 400,
                      "widgetId": "7svn6rcwmd",
                      "renderMode": "CANVAS",
                      "isLoading": false,
                      "parentColumnSpace": 1,
                      "parentRowSpace": 1,
                      "leftColumn": 0,
                      "rightColumn": 145.6875,
                      "topRow": 0,
                      "bottomRow": 1480,
                      "mobileLeftColumn": 0,
                      "mobileRightColumn": 145.6875,
                      "mobileTopRow": 0,
                      "mobileBottomRow": 400,
                      "parentId": "ntxx0f9lsl",
                      "dynamicBindingPathList": []
                    }
                  ],
                  "positioning": "fixed",
                  "responsiveBehavior": "fill",
                  "minWidth": 450,
                  "minDynamicHeight": 10,
                  "maxDynamicHeight": 9000,
                  "dynamicHeight": "AUTO_HEIGHT",
                  "shouldScrollContents": true,
                  "searchTags": [
                    "group"
                  ],
                  "type": "FORM_WIDGET",
                  "hideCard": false,
                  "isDeprecated": false,
                  "displayName": "Form",
                  "key": "33j0xq3l6r",
                  "iconSVG": "./static/media/icon.5d6d2ac5cb1aa68bcd9b14f11c56b44a.svg",
                  "isCanvas": true,
                  "widgetId": "ntxx0f9lsl",
                  "renderMode": "CANVAS",
                  "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                  "boxShadow": "none",
                  "isLoading": false,
                  "parentColumnSpace": 6.9375,
                  "parentRowSpace": 10,
                  "leftColumn": 1,
                  "rightColumn": 123,
                  "topRow": 7,
                  "bottomRow": 155,
                  "mobileLeftColumn": 0,
                  "mobileRightColumn": 21,
                  "mobileTopRow": 25,
                  "mobileBottomRow": 65,
                  "parentId": "bqr7dx0uqs",
                  "dynamicBindingPathList": [
                    {
                      "key": "borderRadius"
                    }
                  ],
                  "originalTopRow": 7,
                  "originalBottomRow": 164,
                  "dynamicTriggerPathList": []
                },
                {
                  "isVisible": true,
                  "iconName": "Close",
                  "buttonVariant": "TERTIARY",
                  "isDisabled": false,
                  "widgetName": "IconButton1Copy",
                  "version": 1,
                  "animateLoading": true,
                  "responsiveBehavior": "hug",
                  "minWidth": 50,
                  "searchTags": [
                    "click",
                    "submit"
                  ],
                  "type": "ICON_BUTTON_WIDGET",
                  "hideCard": false,
                  "isDeprecated": false,
                  "displayName": "Icon button",
                  "key": "h67v63xm4n",
                  "iconSVG": "./static/media/icon.80fc7466c0d7181ec0271de7fda795ec.svg",
                  "buttonColor": "#52525b",
                  "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                  "iconSize": "50",
                  "widgetId": "1bdmgozgzg",
                  "renderMode": "CANVAS",
                  "boxShadow": "none",
                  "isLoading": false,
                  "leftColumn": 122,
                  "rightColumn": 127,
                  "topRow": 1,
                  "bottomRow": 4,
                  "mobileLeftColumn": 58,
                  "mobileRightColumn": 64,
                  "mobileTopRow": 0,
                  "mobileBottomRow": 4,
                  "parentId": "bqr7dx0uqs",
                  "dynamicBindingPathList": [
                    {
                      "key": "borderRadius"
                    }
                  ],
                  "dynamicTriggerPathList": [],
                  "iconColor": "#52525b",
                  "onClick": {
                    "name": "onClick",
                    "status": "add",
                    "label": "触发事件",
                    "children": [
                      {
                        "name": "block",
                        "type": "block",
                        "uid": "e3f091ec31d341f09e56bfbefcb247fd",
                        "children": [
                          {
                            "name": "action",
                            "type": "action",
                            "uid": "97957003949544229e892ded57b99776",
                            "pid": "e3f091ec31d341f09e56bfbefcb247fd",
                            "actionConfig": {
                              "action": "closeModal",
                              "actionId": 328053700189715,
                              "modalName": "edit_Modal",
                              "apiTarget": "1bdmgozgzg"
                            }
                          },
                          {
                            "name": "success",
                            "type": "success",
                            "uid": "d398900c85014d18b665877560b32939",
                            "pid": "e3f091ec31d341f09e56bfbefcb247fd"
                          },
                          {
                            "name": "fail",
                            "type": "fail",
                            "uid": "a7045e9d5e5d44c8bdc7433e1ff5679c",
                            "pid": "e3f091ec31d341f09e56bfbefcb247fd"
                          }
                        ]
                      }
                    ]
                  }
                },
                {
                  "isVisible": true,
                  "text": "编辑数据",
                  "fontSize": "1.25rem",
                  "fontStyle": "BOLD",
                  "textAlign": "LEFT",
                  "textColor": "#231F20",
                  "cancelBind": false,
                  "length": 0,
                  "widgetName": "Text2Copy",
                  "shouldTruncate": false,
                  "overflow": "NONE",
                  "version": 1,
                  "animateLoading": true,
                  "responsiveBehavior": "fill",
                  "minWidth": 450,
                  "minDynamicHeight": 4,
                  "maxDynamicHeight": 9000,
                  "dynamicHeight": "AUTO_HEIGHT",
                  "searchTags": [
                    "typography",
                    "paragraph",
                    "label"
                  ],
                  "type": "TEXT_WIDGET",
                  "hideCard": false,
                  "isDeprecated": false,
                  "displayName": "Text",
                  "key": "7b8xv1p0ao",
                  "iconSVG": "./static/media/icon.c3b6033f570046f8c6288d911333a827.svg",
                  "widgetId": "lctjtgu2l1",
                  "renderMode": "CANVAS",
                  "truncateButtonColor": "{{appsmith.theme.colors.primaryColor}}",
                  "fontFamily": "{{appsmith.theme.fontFamily.appFont}}",
                  "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                  "isLoading": false,
                  "leftColumn": 3,
                  "rightColumn": 43,
                  "topRow": 2,
                  "bottomRow": 6,
                  "mobileLeftColumn": 1,
                  "mobileRightColumn": 41,
                  "mobileTopRow": 1,
                  "mobileBottomRow": 5,
                  "parentId": "bqr7dx0uqs",
                  "dynamicBindingPathList": [
                    {
                      "key": "truncateButtonColor"
                    },
                    {
                      "key": "fontFamily"
                    },
                    {
                      "key": "borderRadius"
                    }
                  ],
                  "dynamicTriggerPathList": []
                }
              ],
              "minHeight": 1220,
              "widgetId": "bqr7dx0uqs",
              "renderMode": "CANVAS",
              "isLoading": false,
              "parentColumnSpace": 1,
              "parentRowSpace": 1,
              "leftColumn": 0,
              "rightColumn": 334.96875,
              "topRow": 0,
              "bottomRow": 1570,
              "mobileLeftColumn": 0,
              "mobileRightColumn": 334.96875,
              "mobileTopRow": 0,
              "mobileBottomRow": 240,
              "parentId": "ymwpa5s74k",
              "dynamicBindingPathList": []
            }
          ],
          "version": 2,
          "maxDynamicHeight": 9000,
          "dynamicHeight": "AUTO_HEIGHT",
          "searchTags": [
            "dialog",
            "popup",
            "notification"
          ],
          "type": "MODAL_WIDGET",
          "hideCard": false,
          "isDeprecated": false,
          "displayName": "Modal",
          "key": "5frlqanmhf",
          "iconSVG": "./static/media/icon.d2ab7de0666eaef853cc2d330f86887b.svg",
          "isCanvas": true,
          "widgetId": "ymwpa5s74k",
          "renderMode": "CANVAS",
          "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
          "boxShadow": "none",
          "isLoading": false,
          "parentColumnSpace": 13.95703125,
          "parentRowSpace": 10,
          "leftColumn": 6,
          "rightColumn": 30,
          "topRow": 156,
          "bottomRow": 157,
          "mobileLeftColumn": 6,
          "mobileRightColumn": 30,
          "mobileTopRow": 11,
          "mobileBottomRow": 35,
          "parentId": "0",
          "dynamicBindingPathList": [
            {
              "key": "borderRadius"
            }
          ],
          "minHeight": 1570,
          "dynamicTriggerPathList": []
        },
        {
          "width": 456,
          "height": 158,
          "minDynamicHeight": 24,
          "canEscapeKeyClose": true,
          "animateLoading": true,
          "detachFromLayout": true,
          "canOutsideClickClose": true,
          "shouldScrollContents": true,
          "widgetName": "delete_Modal",
          "children": [
            {
              "isVisible": true,
              "widgetName": "Canvas5",
              "version": 1,
              "detachFromLayout": true,
              "flexLayers": [],
              "responsiveBehavior": "fill",
              "minWidth": 450,
              "type": "CANVAS_WIDGET",
              "hideCard": true,
              "isDeprecated": false,
              "displayName": "Canvas",
              "key": "ymn28jtkbi",
              "canExtend": true,
              "isDisabled": false,
              "shouldScrollContents": false,
              "children": [
                {
                  "isVisible": true,
                  "iconName": "Close",
                  "buttonVariant": "TERTIARY",
                  "isDisabled": false,
                  "widgetName": "IconButton1Copy1",
                  "version": 1,
                  "animateLoading": true,
                  "responsiveBehavior": "hug",
                  "minWidth": 50,
                  "searchTags": [
                    "click",
                    "submit"
                  ],
                  "type": "ICON_BUTTON_WIDGET",
                  "hideCard": false,
                  "isDeprecated": false,
                  "displayName": "Icon button",
                  "key": "h67v63xm4n",
                  "iconSVG": "./static/media/icon.80fc7466c0d7181ec0271de7fda795ec.svg",
                  "buttonColor": "#52525b",
                  "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                  "iconSize": "50",
                  "widgetId": "puk7u3xx09",
                  "renderMode": "CANVAS",
                  "boxShadow": "none",
                  "isLoading": false,
                  "leftColumn": 119,
                  "rightColumn": 124,
                  "topRow": 1,
                  "bottomRow": 4,
                  "mobileLeftColumn": 58,
                  "mobileRightColumn": 64,
                  "mobileTopRow": 0,
                  "mobileBottomRow": 4,
                  "parentId": "pk7q648kvt",
                  "dynamicBindingPathList": [
                    {
                      "key": "borderRadius"
                    }
                  ],
                  "dynamicTriggerPathList": [],
                  "iconColor": "#52525b"
                },
                {
                  "isVisible": true,
                  "animateLoading": true,
                  "text": "取消",
                  "buttonVariant": "SECONDARY",
                  "placement": "CENTER",
                  "widgetName": "Button8",
                  "isDisabled": false,
                  "isDefaultClickDisabled": true,
                  "disabledWhenInvalid": false,
                  "resetFormOnClick": false,
                  "recaptchaType": "V3",
                  "version": 1,
                  "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                  "responsiveBehavior": "hug",
                  "minWidth": 120,
                  "searchTags": [
                    "click",
                    "submit"
                  ],
                  "type": "BUTTON_WIDGET",
                  "hideCard": false,
                  "isDeprecated": false,
                  "displayName": "Button",
                  "key": "9qcv6rozpb",
                  "iconSVG": "./static/media/icon.2075e59f4c855dc62f664870206244a0.svg",
                  "buttonStyle": "PRIMARY",
                  "widgetId": "re02hoxq9e",
                  "renderMode": "CANVAS",
                  "buttonColor": "{{appsmith.theme.colors.primaryColor}}",
                  "boxShadow": "{{appsmith.theme.boxShadow.appBoxShadow}}",
                  "isLoading": false,
                  "leftColumn": 81,
                  "rightColumn": 101,
                  "topRow": 10,
                  "bottomRow": 13,
                  "mobileLeftColumn": 31,
                  "mobileRightColumn": 47,
                  "mobileTopRow": 18,
                  "mobileBottomRow": 22,
                  "parentId": "pk7q648kvt",
                  "dynamicBindingPathList": [
                    {
                      "key": "buttonColor"
                    },
                    {
                      "key": "borderRadius"
                    },
                    {
                      "key": "boxShadow"
                    }
                  ],
                  "onClick": {
                    "name": "onClick",
                    "status": "edit",
                    "label": "触发事件",
                    "children": [
                      {
                        "name": "block",
                        "type": "block",
                        "uid": "e64ab04bc8da44a0b2b14a57492bd3a6",
                        "children": [
                          {
                            "name": "action",
                            "type": "action",
                            "uid": "e1d66fb4c0284e96aefce015c066f212",
                            "pid": "e64ab04bc8da44a0b2b14a57492bd3a6",
                            "actionConfig": {
                              "action": "closeModal",
                              "actionId": 178899498243709,
                              "modalName": "delete_Modal",
                              "apiTarget": "re02hoxq9e"
                            }
                          },
                          {
                            "name": "success",
                            "type": "success",
                            "uid": "3723f8bd765e4547b15843df5cedede1",
                            "pid": "e64ab04bc8da44a0b2b14a57492bd3a6"
                          },
                          {
                            "name": "fail",
                            "type": "fail",
                            "uid": "ca79e76e5ada47a393c7a22bd63ab623",
                            "pid": "e64ab04bc8da44a0b2b14a57492bd3a6"
                          }
                        ]
                      }
                    ]
                  },
                  "dynamicTriggerPathList": []
                },
                {
                  "isVisible": true,
                  "animateLoading": true,
                  "text": "确定",
                  "buttonVariant": "PRIMARY",
                  "placement": "CENTER",
                  "widgetName": "Button9",
                  "isDisabled": false,
                  "isDefaultClickDisabled": true,
                  "disabledWhenInvalid": false,
                  "resetFormOnClick": false,
                  "recaptchaType": "V3",
                  "version": 1,
                  "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                  "responsiveBehavior": "hug",
                  "minWidth": 120,
                  "searchTags": [
                    "click",
                    "submit"
                  ],
                  "type": "BUTTON_WIDGET",
                  "hideCard": false,
                  "isDeprecated": false,
                  "displayName": "Button",
                  "key": "9qcv6rozpb",
                  "iconSVG": "./static/media/icon.2075e59f4c855dc62f664870206244a0.svg",
                  "buttonStyle": "PRIMARY_BUTTON",
                  "widgetId": "zr3yw0uzcm",
                  "renderMode": "CANVAS",
                  "buttonColor": "{{appsmith.theme.colors.primaryColor}}",
                  "boxShadow": "{{appsmith.theme.boxShadow.appBoxShadow}}",
                  "isLoading": false,
                  "leftColumn": 103,
                  "rightColumn": 124,
                  "topRow": 10,
                  "bottomRow": 13,
                  "mobileLeftColumn": 47,
                  "mobileRightColumn": 63,
                  "mobileTopRow": 18,
                  "mobileBottomRow": 22,
                  "parentId": "pk7q648kvt",
                  "dynamicBindingPathList": [
                    {
                      "key": "buttonColor"
                    },
                    {
                      "key": "borderRadius"
                    },
                    {
                      "key": "boxShadow"
                    }
                  ],
                  "dynamicTriggerPathList": []
                },
                {
                  "isVisible": true,
                  "text": "确定删除这条数据吗？",
                  "fontSize": "1rem",
                  "fontStyle": "",
                  "textAlign": "LEFT",
                  "textColor": "#231F20",
                  "cancelBind": false,
                  "length": 0,
                  "widgetName": "Text4",
                  "shouldTruncate": false,
                  "overflow": "NONE",
                  "version": 1,
                  "animateLoading": true,
                  "responsiveBehavior": "fill",
                  "minWidth": 450,
                  "minDynamicHeight": 4,
                  "maxDynamicHeight": 9000,
                  "dynamicHeight": "FIXED",
                  "searchTags": [
                    "typography",
                    "paragraph",
                    "label"
                  ],
                  "type": "TEXT_WIDGET",
                  "hideCard": false,
                  "isDeprecated": false,
                  "displayName": "Text",
                  "key": "7b8xv1p0ao",
                  "iconSVG": "./static/media/icon.c3b6033f570046f8c6288d911333a827.svg",
                  "widgetId": "kmrtygrjob",
                  "renderMode": "CANVAS",
                  "truncateButtonColor": "{{appsmith.theme.colors.primaryColor}}",
                  "fontFamily": "{{appsmith.theme.fontFamily.appFont}}",
                  "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                  "isLoading": false,
                  "parentColumnSpace": 6.9375,
                  "parentRowSpace": 10,
                  "leftColumn": 16,
                  "rightColumn": 78,
                  "topRow": 5,
                  "bottomRow": 8,
                  "mobileLeftColumn": 2,
                  "mobileRightColumn": 18,
                  "mobileTopRow": 7,
                  "mobileBottomRow": 11,
                  "parentId": "pk7q648kvt",
                  "dynamicBindingPathList": [
                    {
                      "key": "truncateButtonColor"
                    },
                    {
                      "key": "fontFamily"
                    },
                    {
                      "key": "borderRadius"
                    }
                  ],
                  "dynamicTriggerPathList": []
                },
                {
                  "isVisible": true,
                  "iconName": "Caution",
                  "buttonVariant": "TERTIARY",
                  "isDisabled": false,
                  "widgetName": "IconButton2",
                  "version": 1,
                  "animateLoading": true,
                  "responsiveBehavior": "hug",
                  "minWidth": 50,
                  "searchTags": [
                    "click",
                    "submit"
                  ],
                  "type": "ICON_BUTTON_WIDGET",
                  "hideCard": false,
                  "isDeprecated": false,
                  "displayName": "Icon button",
                  "key": "h67v63xm4n",
                  "iconSVG": "./static/media/icon.80fc7466c0d7181ec0271de7fda795ec.svg",
                  "widgetId": "q5ayehp5zv",
                  "renderMode": "CANVAS",
                  "buttonColor": "#eab308",
                  "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                  "boxShadow": "none",
                  "isLoading": false,
                  "parentColumnSpace": 6.9375,
                  "parentRowSpace": 10,
                  "leftColumn": 8,
                  "rightColumn": 14,
                  "topRow": 5,
                  "bottomRow": 8,
                  "mobileLeftColumn": 1,
                  "mobileRightColumn": 5,
                  "mobileTopRow": 6,
                  "mobileBottomRow": 10,
                  "parentId": "pk7q648kvt",
                  "dynamicBindingPathList": [
                    {
                      "key": "borderRadius"
                    }
                  ],
                  "dynamicTriggerPathList": []
                },
                {
                  "isVisible": true,
                  "text": "删除数据",
                  "fontSize": "1.25rem",
                  "fontStyle": "BOLD",
                  "textAlign": "LEFT",
                  "textColor": "{{appsmith.theme.colors.textColor}}",
                  "cancelBind": false,
                  "length": 0,
                  "widgetName": "Text6",
                  "shouldTruncate": false,
                  "overflow": "NONE",
                  "version": 1,
                  "animateLoading": true,
                  "responsiveBehavior": "fill",
                  "minWidth": 375,
                  "dataFormat": "",
                  "searchTags": [
                    "typography",
                    "paragraph",
                    "label"
                  ],
                  "type": "TEXT_WIDGET",
                  "hideCard": false,
                  "isDeprecated": false,
                  "displayName": "Text",
                  "key": "kghmklemcm",
                  "iconSVG": "./static/media/icon.c3b6033f570046f8c6288d911333a827.svg",
                  "widgetId": "46huyhao0t",
                  "renderMode": "CANVAS",
                  "truncateButtonColor": "{{appsmith.theme.colors.primaryColor}}",
                  "fontFamily": "{{appsmith.theme.fontFamily.appFont}}",
                  "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                  "isLoading": false,
                  "parentColumnSpace": 3.5625,
                  "parentRowSpace": 10,
                  "leftColumn": 4,
                  "rightColumn": 30,
                  "topRow": 1,
                  "bottomRow": 4,
                  "mobileLeftColumn": 4,
                  "mobileRightColumn": 20,
                  "mobileTopRow": 1,
                  "mobileBottomRow": 4,
                  "parentId": "pk7q648kvt",
                  "dynamicBindingPathList": [
                    {
                      "key": "truncateButtonColor"
                    },
                    {
                      "key": "fontFamily"
                    },
                    {
                      "key": "borderRadius"
                    },
                    {
                      "key": "textColor"
                    }
                  ],
                  "dynamicTriggerPathList": []
                }
              ],
              "minHeight": 158,
              "widgetId": "pk7q648kvt",
              "renderMode": "CANVAS",
              "isLoading": false,
              "parentColumnSpace": 1,
              "parentRowSpace": 1,
              "leftColumn": 0,
              "rightColumn": 334.96875,
              "topRow": 0,
              "bottomRow": 150,
              "mobileLeftColumn": 0,
              "mobileRightColumn": 334.96875,
              "mobileTopRow": 0,
              "mobileBottomRow": 240,
              "parentId": "evf9vq7uwa",
              "dynamicBindingPathList": []
            }
          ],
          "version": 2,
          "maxDynamicHeight": 9000,
          "dynamicHeight": "FIXED",
          "searchTags": [
            "dialog",
            "popup",
            "notification"
          ],
          "type": "MODAL_WIDGET",
          "hideCard": false,
          "isDeprecated": false,
          "displayName": "Modal",
          "key": "5frlqanmhf",
          "iconSVG": "./static/media/icon.d2ab7de0666eaef853cc2d330f86887b.svg",
          "isCanvas": true,
          "widgetId": "evf9vq7uwa",
          "renderMode": "CANVAS",
          "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
          "boxShadow": "none",
          "isLoading": false,
          "parentColumnSpace": 13.95703125,
          "parentRowSpace": 10,
          "leftColumn": 2,
          "rightColumn": 26,
          "topRow": 18,
          "bottomRow": 258,
          "mobileLeftColumn": 2,
          "mobileRightColumn": 26,
          "mobileTopRow": 18,
          "mobileBottomRow": 42,
          "parentId": "0",
          "dynamicBindingPathList": [
            {
              "key": "borderRadius"
            }
          ],
          "dynamicTriggerPathList": []
        },
        {
          "width": 456,
          "height": 158,
          "minDynamicHeight": 24,
          "canEscapeKeyClose": true,
          "animateLoading": true,
          "detachFromLayout": true,
          "canOutsideClickClose": true,
          "shouldScrollContents": true,
          "widgetName": "muldelete_Modal",
          "children": [
            {
              "isVisible": true,
              "widgetName": "Canvas5Copy",
              "version": 1,
              "detachFromLayout": true,
              "flexLayers": [],
              "responsiveBehavior": "fill",
              "minWidth": 450,
              "type": "CANVAS_WIDGET",
              "hideCard": true,
              "isDeprecated": false,
              "displayName": "Canvas",
              "key": "ymn28jtkbi",
              "canExtend": true,
              "isDisabled": false,
              "shouldScrollContents": false,
              "children": [
                {
                  "isVisible": true,
                  "iconName": "Close",
                  "buttonVariant": "TERTIARY",
                  "isDisabled": false,
                  "widgetName": "IconButton1Copy1Copy",
                  "version": 1,
                  "animateLoading": true,
                  "responsiveBehavior": "hug",
                  "minWidth": 50,
                  "searchTags": [
                    "click",
                    "submit"
                  ],
                  "type": "ICON_BUTTON_WIDGET",
                  "hideCard": false,
                  "isDeprecated": false,
                  "displayName": "Icon button",
                  "key": "h67v63xm4n",
                  "iconSVG": "./static/media/icon.80fc7466c0d7181ec0271de7fda795ec.svg",
                  "buttonColor": "#52525b",
                  "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                  "iconSize": "50",
                  "widgetId": "1kf88a5gzn",
                  "renderMode": "CANVAS",
                  "boxShadow": "none",
                  "isLoading": false,
                  "leftColumn": 119,
                  "rightColumn": 124,
                  "topRow": 1,
                  "bottomRow": 4,
                  "mobileLeftColumn": 58,
                  "mobileRightColumn": 64,
                  "mobileTopRow": 0,
                  "mobileBottomRow": 4,
                  "parentId": "4sc2hzim9i",
                  "dynamicBindingPathList": [
                    {
                      "key": "borderRadius"
                    }
                  ],
                  "dynamicTriggerPathList": [],
                  "iconColor": "#52525b",
                  "onClick": {
                    "name": "onClick",
                    "status": "add",
                    "label": "触发事件",
                    "children": [
                      {
                        "name": "block",
                        "type": "block",
                        "uid": "0979b96adcce4c5bba33da828288e509",
                        "children": [
                          {
                            "name": "action",
                            "type": "action",
                            "uid": "83284d50fd134ca6902b99ec340eade0",
                            "pid": "0979b96adcce4c5bba33da828288e509",
                            "actionConfig": {
                              "action": "closeModal",
                              "actionId": 328053708576896,
                              "modalName": "muldelete_Modal",
                              "apiTarget": "1kf88a5gzn"
                            }
                          },
                          {
                            "name": "success",
                            "type": "success",
                            "uid": "aa80d809678f4765ad7ebaebf6444e6b",
                            "pid": "0979b96adcce4c5bba33da828288e509"
                          },
                          {
                            "name": "fail",
                            "type": "fail",
                            "uid": "b1df5ed8579e480c9547e9a81186f437",
                            "pid": "0979b96adcce4c5bba33da828288e509"
                          }
                        ]
                      }
                    ]
                  }
                },
                {
                  "isVisible": true,
                  "animateLoading": true,
                  "text": "取消",
                  "buttonVariant": "SECONDARY",
                  "placement": "CENTER",
                  "widgetName": "Button8Copy",
                  "isDisabled": false,
                  "isDefaultClickDisabled": true,
                  "disabledWhenInvalid": false,
                  "resetFormOnClick": false,
                  "recaptchaType": "V3",
                  "version": 1,
                  "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                  "responsiveBehavior": "hug",
                  "minWidth": 120,
                  "searchTags": [
                    "click",
                    "submit"
                  ],
                  "type": "BUTTON_WIDGET",
                  "hideCard": false,
                  "isDeprecated": false,
                  "displayName": "Button",
                  "key": "9qcv6rozpb",
                  "iconSVG": "./static/media/icon.2075e59f4c855dc62f664870206244a0.svg",
                  "buttonStyle": "PRIMARY",
                  "widgetId": "xkgfbnmp7b",
                  "renderMode": "CANVAS",
                  "buttonColor": "{{appsmith.theme.colors.primaryColor}}",
                  "boxShadow": "{{appsmith.theme.boxShadow.appBoxShadow}}",
                  "isLoading": false,
                  "leftColumn": 81,
                  "rightColumn": 101,
                  "topRow": 10,
                  "bottomRow": 13,
                  "mobileLeftColumn": 31,
                  "mobileRightColumn": 47,
                  "mobileTopRow": 18,
                  "mobileBottomRow": 22,
                  "parentId": "4sc2hzim9i",
                  "dynamicBindingPathList": [
                    {
                      "key": "buttonColor"
                    },
                    {
                      "key": "borderRadius"
                    },
                    {
                      "key": "boxShadow"
                    }
                  ],
                  "dynamicTriggerPathList": [],
                  "onClick": {
                    "name": "onClick",
                    "status": "add",
                    "label": "触发事件",
                    "children": [
                      {
                        "name": "block",
                        "type": "block",
                        "uid": "65a22e9954764798a38f2d6fc9091487",
                        "children": [
                          {
                            "name": "action",
                            "type": "action",
                            "uid": "3298c09b0999483c86db00a77d85fa5a",
                            "pid": "65a22e9954764798a38f2d6fc9091487",
                            "actionConfig": {
                              "action": "closeModal",
                              "actionId": 328053708576908,
                              "modalName": "muldelete_Modal",
                              "apiTarget": "xkgfbnmp7b"
                            }
                          },
                          {
                            "name": "success",
                            "type": "success",
                            "uid": "9f965f405f3842a2bf92397569d9a43a",
                            "pid": "65a22e9954764798a38f2d6fc9091487"
                          },
                          {
                            "name": "fail",
                            "type": "fail",
                            "uid": "0947fe3c0d7941708d4b45349614ad27",
                            "pid": "65a22e9954764798a38f2d6fc9091487"
                          }
                        ]
                      }
                    ]
                  }
                },
                {
                  "isVisible": true,
                  "animateLoading": true,
                  "text": "确定",
                  "buttonVariant": "PRIMARY",
                  "placement": "CENTER",
                  "widgetName": "Button9Copy",
                  "isDisabled": false,
                  "isDefaultClickDisabled": true,
                  "disabledWhenInvalid": false,
                  "resetFormOnClick": false,
                  "recaptchaType": "V3",
                  "version": 1,
                  "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                  "responsiveBehavior": "hug",
                  "minWidth": 120,
                  "searchTags": [
                    "click",
                    "submit"
                  ],
                  "type": "BUTTON_WIDGET",
                  "hideCard": false,
                  "isDeprecated": false,
                  "displayName": "Button",
                  "key": "9qcv6rozpb",
                  "iconSVG": "./static/media/icon.2075e59f4c855dc62f664870206244a0.svg",
                  "buttonStyle": "PRIMARY_BUTTON",
                  "widgetId": "2oo5u0t9aq",
                  "renderMode": "CANVAS",
                  "buttonColor": "{{appsmith.theme.colors.primaryColor}}",
                  "boxShadow": "{{appsmith.theme.boxShadow.appBoxShadow}}",
                  "isLoading": false,
                  "leftColumn": 103,
                  "rightColumn": 124,
                  "topRow": 10,
                  "bottomRow": 13,
                  "mobileLeftColumn": 47,
                  "mobileRightColumn": 63,
                  "mobileTopRow": 18,
                  "mobileBottomRow": 22,
                  "parentId": "4sc2hzim9i",
                  "dynamicBindingPathList": [
                    {
                      "key": "buttonColor"
                    },
                    {
                      "key": "borderRadius"
                    },
                    {
                      "key": "boxShadow"
                    }
                  ],
                  "dynamicTriggerPathList": [],
                },
                {
                  "isVisible": true,
                  "text": "确定删除这些数据吗？",
                  "fontSize": "1rem",
                  "fontStyle": "",
                  "textAlign": "LEFT",
                  "textColor": "#231F20",
                  "cancelBind": false,
                  "length": 0,
                  "widgetName": "Text4Copy",
                  "shouldTruncate": false,
                  "overflow": "NONE",
                  "version": 1,
                  "animateLoading": true,
                  "responsiveBehavior": "fill",
                  "minWidth": 450,
                  "minDynamicHeight": 4,
                  "maxDynamicHeight": 9000,
                  "dynamicHeight": "FIXED",
                  "searchTags": [
                    "typography",
                    "paragraph",
                    "label"
                  ],
                  "type": "TEXT_WIDGET",
                  "hideCard": false,
                  "isDeprecated": false,
                  "displayName": "Text",
                  "key": "7b8xv1p0ao",
                  "iconSVG": "./static/media/icon.c3b6033f570046f8c6288d911333a827.svg",
                  "widgetId": "lrrwonm5fm",
                  "renderMode": "CANVAS",
                  "truncateButtonColor": "{{appsmith.theme.colors.primaryColor}}",
                  "fontFamily": "{{appsmith.theme.fontFamily.appFont}}",
                  "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                  "isLoading": false,
                  "parentColumnSpace": 6.9375,
                  "parentRowSpace": 10,
                  "leftColumn": 16,
                  "rightColumn": 78,
                  "topRow": 5,
                  "bottomRow": 8,
                  "mobileLeftColumn": 2,
                  "mobileRightColumn": 18,
                  "mobileTopRow": 7,
                  "mobileBottomRow": 11,
                  "parentId": "4sc2hzim9i",
                  "dynamicBindingPathList": [
                    {
                      "key": "truncateButtonColor"
                    },
                    {
                      "key": "fontFamily"
                    },
                    {
                      "key": "borderRadius"
                    }
                  ],
                  "dynamicTriggerPathList": []
                },
                {
                  "isVisible": true,
                  "iconName": "Caution",
                  "buttonVariant": "TERTIARY",
                  "isDisabled": false,
                  "widgetName": "IconButton2Copy",
                  "version": 1,
                  "animateLoading": true,
                  "responsiveBehavior": "hug",
                  "minWidth": 50,
                  "searchTags": [
                    "click",
                    "submit"
                  ],
                  "type": "ICON_BUTTON_WIDGET",
                  "hideCard": false,
                  "isDeprecated": false,
                  "displayName": "Icon button",
                  "key": "h67v63xm4n",
                  "iconSVG": "./static/media/icon.80fc7466c0d7181ec0271de7fda795ec.svg",
                  "widgetId": "swyvdhdjlp",
                  "renderMode": "CANVAS",
                  "buttonColor": "#eab308",
                  "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                  "boxShadow": "none",
                  "isLoading": false,
                  "parentColumnSpace": 6.9375,
                  "parentRowSpace": 10,
                  "leftColumn": 8,
                  "rightColumn": 14,
                  "topRow": 5,
                  "bottomRow": 8,
                  "mobileLeftColumn": 1,
                  "mobileRightColumn": 5,
                  "mobileTopRow": 6,
                  "mobileBottomRow": 10,
                  "parentId": "4sc2hzim9i",
                  "dynamicBindingPathList": [
                    {
                      "key": "borderRadius"
                    }
                  ],
                  "dynamicTriggerPathList": []
                },
                {
                  "isVisible": true,
                  "text": "删除数据",
                  "fontSize": "1.25rem",
                  "fontStyle": "BOLD",
                  "textAlign": "LEFT",
                  "textColor": "{{appsmith.theme.colors.textColor}}",
                  "cancelBind": false,
                  "length": 0,
                  "widgetName": "Text6Copy",
                  "shouldTruncate": false,
                  "overflow": "NONE",
                  "version": 1,
                  "animateLoading": true,
                  "responsiveBehavior": "fill",
                  "minWidth": 375,
                  "dataFormat": "",
                  "searchTags": [
                    "typography",
                    "paragraph",
                    "label"
                  ],
                  "type": "TEXT_WIDGET",
                  "hideCard": false,
                  "isDeprecated": false,
                  "displayName": "Text",
                  "key": "kghmklemcm",
                  "iconSVG": "./static/media/icon.c3b6033f570046f8c6288d911333a827.svg",
                  "widgetId": "1zlvhcmiw4",
                  "renderMode": "CANVAS",
                  "truncateButtonColor": "{{appsmith.theme.colors.primaryColor}}",
                  "fontFamily": "{{appsmith.theme.fontFamily.appFont}}",
                  "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                  "isLoading": false,
                  "parentColumnSpace": 3.5625,
                  "parentRowSpace": 10,
                  "leftColumn": 4,
                  "rightColumn": 30,
                  "topRow": 1,
                  "bottomRow": 4,
                  "mobileLeftColumn": 4,
                  "mobileRightColumn": 20,
                  "mobileTopRow": 1,
                  "mobileBottomRow": 4,
                  "parentId": "4sc2hzim9i",
                  "dynamicBindingPathList": [
                    {
                      "key": "truncateButtonColor"
                    },
                    {
                      "key": "fontFamily"
                    },
                    {
                      "key": "borderRadius"
                    },
                    {
                      "key": "textColor"
                    }
                  ],
                  "dynamicTriggerPathList": []
                }
              ],
              "minHeight": 158,
              "widgetId": "4sc2hzim9i",
              "renderMode": "CANVAS",
              "isLoading": false,
              "parentColumnSpace": 1,
              "parentRowSpace": 1,
              "leftColumn": 0,
              "rightColumn": 334.96875,
              "topRow": 0,
              "bottomRow": 150,
              "mobileLeftColumn": 0,
              "mobileRightColumn": 334.96875,
              "mobileTopRow": 0,
              "mobileBottomRow": 240,
              "parentId": "5891vgukn3",
              "dynamicBindingPathList": []
            }
          ],
          "version": 2,
          "maxDynamicHeight": 9000,
          "dynamicHeight": "FIXED",
          "searchTags": [
            "dialog",
            "popup",
            "notification"
          ],
          "type": "MODAL_WIDGET",
          "hideCard": false,
          "isDeprecated": false,
          "displayName": "Modal",
          "key": "5frlqanmhf",
          "iconSVG": "./static/media/icon.d2ab7de0666eaef853cc2d330f86887b.svg",
          "isCanvas": true,
          "widgetId": "5891vgukn3",
          "renderMode": "CANVAS",
          "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
          "boxShadow": "none",
          "isLoading": false,
          "parentColumnSpace": 13.95703125,
          "parentRowSpace": 10,
          "leftColumn": 2,
          "rightColumn": 26,
          "topRow": 14,
          "bottomRow": 254,
          "mobileLeftColumn": 2,
          "mobileRightColumn": 26,
          "mobileTopRow": 18,
          "mobileBottomRow": 42,
          "parentId": "0",
          "dynamicBindingPathList": [
            {
              "key": "borderRadius"
            }
          ],
          "dynamicTriggerPathList": []
        },
        {
          "isVisible": true,
          "borderColor": "#E0DEDE",
          "borderWidth": "0",
          "animateLoading": true,
          "widgetName": "SearchForm1",
          "backgroundColor": "#FFFFFF",
          "children": [
            {
              "isVisible": true,
              "widgetName": "Canvas6",
              "version": 1,
              "detachFromLayout": true,
              "flexLayers": [],
              "responsiveBehavior": "fill",
              "minWidth": 375,
              "type": "CANVAS_WIDGET",
              "hideCard": true,
              "isDeprecated": false,
              "displayName": "Canvas",
              "key": "uf0xs0zvcs",
              "containerStyle": "none",
              "canExtend": false,
              "children": [
                {
                  "isVisible": true,
                  "text": "查询条件",
                  "fontSize": "1rem",
                  "fontStyle": "BOLD",
                  "textAlign": "LEFT",
                  "textColor": "{{appsmith.theme.colors.textColor}}",
                  "cancelBind": false,
                  "length": 0,
                  "widgetName": "Text5",
                  "shouldTruncate": false,
                  "overflow": "NONE",
                  "version": 1,
                  "animateLoading": true,
                  "responsiveBehavior": "fill",
                  "minWidth": 375,
                  "dataFormat": "",
                  "searchTags": [
                    "typography",
                    "paragraph",
                    "label"
                  ],
                  "type": "TEXT_WIDGET",
                  "hideCard": false,
                  "isDeprecated": false,
                  "displayName": "Text",
                  "key": "yzu5b947ct",
                  "iconSVG": "./static/media/icon.c3b6033f570046f8c6288d911333a827.svg",
                  "widgetId": "qn1ohdvcoe",
                  "renderMode": "CANVAS",
                  "truncateButtonColor": "{{appsmith.theme.colors.primaryColor}}",
                  "fontFamily": "{{appsmith.theme.fontFamily.appFont}}",
                  "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                  "isLoading": false,
                  "parentColumnSpace": 8.251590728759766,
                  "parentRowSpace": 10,
                  "leftColumn": 2,
                  "rightColumn": 18,
                  "topRow": 1,
                  "bottomRow": 4,
                  "mobileLeftColumn": 1,
                  "mobileRightColumn": 17,
                  "mobileTopRow": 1,
                  "mobileBottomRow": 4,
                  "parentId": "fjg5c81ngj",
                  "dynamicBindingPathList": [
                    {
                      "key": "truncateButtonColor"
                    },
                    {
                      "key": "fontFamily"
                    },
                    {
                      "key": "borderRadius"
                    },
                    {
                      "key": "textColor"
                    }
                  ],
                  "dynamicTriggerPathList": []
                },
                {
                  "isVisible": true,
                  "defaultImage": "https://assets.appsmith.com/widgets/default.png",
                  "imageShape": "RECTANGLE",
                  "maxZoomLevel": 1,
                  "enableRotation": false,
                  "enableDownload": false,
                  "objectFit": "cover",
                  "widgetName": "dateTimeSearch",
                  "version": 1,
                  "animateLoading": true,
                  "showTime": false,
                  "placeholderText1": "请选择开始日期",
                  "placeholderText2": "请选择结束日期",
                  "labelText": "日期时间",
                  "labelPosition": "Left",
                  "labelAlignment": "right",
                  "labelWidth": 8,
                  "isReadonly": false,
                  "defaultValue": [],
                  "dateFormat": "YYYY-MM-DD",
                  "minDynamicHeight": 3,
                  "maxDynamicHeight": 9000,
                  "dynamicHeight": "AUTO_HEIGHT",
                  "type": "RANGEDATEPICKER_WIDGET",
                  "hideCard": false,
                  "isDeprecated": false,
                  "displayName": "dateTime",
                  "key": "734D220784E5B66E",
                  "iconSVG": "./static/media/icon.b4924e96812d710d2a66d9c44e0179ec.svg",
                  "widgetId": "8D51D9F45D6FFB5D",
                  "renderMode": "CANVAS",
                  "accentColor": "{{appsmith.theme.colors.primaryColor}}",
                  "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                  "boxShadow": "{{appsmith.theme.boxShadow.appBoxShadow}}",
                  "it_color": "{{appsmith.theme.form.inputText.fontColor}}",
                  "it_size": "{{appsmith.theme.form.inputText.fontSize}}",
                  "it_style": "{{appsmith.theme.form.inputText.fontStyle}}",
                  "labelTextColor": "{{appsmith.theme.form.label.fontColor}}",
                  "labelTextSize": "{{appsmith.theme.form.label.fontSize}}",
                  "labelStyle": "{{appsmith.theme.form.label.fontStyle}}",
                  "ib_bgColor": "{{appsmith.theme.form.inputBorder.bgColor}}",
                  "ib_borderColor": "{{appsmith.theme.form.inputBorder.bgBorderColor}}",
                  "isLoading": false,
                  "parentColumnSpace": 10.1513671875,
                  "parentRowSpace": 10,
                  "leftColumn": 3,
                  "rightColumn": 61,
                  "topRow": 5,
                  "bottomRow": 8,
                  "mobileLeftColumn": 62,
                  "mobileRightColumn": 90,
                  "mobileTopRow": 6,
                  "mobileBottomRow": 9,
                  "parentId": "fjg5c81ngj",
                  "dynamicBindingPathList": [
                    {
                      "key": "accentColor"
                    },
                    {
                      "key": "borderRadius"
                    },
                    {
                      "key": "boxShadow"
                    },
                    {
                      "key": "it_color"
                    },
                    {
                      "key": "it_size"
                    },
                    {
                      "key": "it_style"
                    },
                    {
                      "key": "labelTextColor"
                    },
                    {
                      "key": "labelTextSize"
                    },
                    {
                      "key": "labelStyle"
                    },
                    {
                      "key": "ib_bgColor"
                    },
                    {
                      "key": "ib_borderColor"
                    }
                  ],
                  "label": "日期时间"
                },
                {
                  "isVisible": true,
                  "placeholderText": "请选择",
                  "labelText": "选项",
                  "labelPosition": "Left",
                  "labelAlignment": "right",
                  "labelWidth": 8,
                  "selectId": 366465321725578,
                  "defaultOptions": [],
                  "serverSideFiltering": false,
                  "widgetName": "dictSearch",
                  "defaultOptionValue": null,
                  "defaultOptionLabel": null,
                  "version": 1,
                  "isFilterable": true,
                  "isRequired": false,
                  "isDisabled": false,
                  "isReadonly": false,
                  "animateLoading": true,
                  "responsiveBehavior": "fill",
                  "minWidth": 375,
                  "minDynamicHeight": 3,
                  "maxDynamicHeight": 9000,
                  "dynamicHeight": "AUTO_HEIGHT",
                  "searchTags": [
                    "dropdown"
                  ],
                  "type": "SELECT_WIDGET",
                  "hideCard": false,
                  "isDeprecated": false,
                  "displayName": "dict",
                  "key": "98BD91369B4FDDC9",
                  "iconSVG": "./static/media/icon.1a5defb3c19b4cac4a27829d1f979e4c.svg",
                  "widgetId": "B6EBB49C7B0383B7",
                  "renderMode": "CANVAS",
                  "accentColor": "{{appsmith.theme.colors.primaryColor}}",
                  "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                  "boxShadow": "{{appsmith.theme.boxShadow.appBoxShadow}}",
                  "it_color": "{{appsmith.theme.form.inputText.fontColor}}",
                  "it_size": "{{appsmith.theme.form.inputText.fontSize}}",
                  "it_style": "{{appsmith.theme.form.inputText.fontStyle}}",
                  "labelTextColor": "{{appsmith.theme.form.label.fontColor}}",
                  "labelTextSize": "{{appsmith.theme.form.label.fontSize}}",
                  "labelStyle": "{{appsmith.theme.form.label.fontStyle}}",
                  "ib_bgColor": "{{appsmith.theme.form.inputBorder.bgColor}}",
                  "ib_borderColor": "{{appsmith.theme.form.inputBorder.bgBorderColor}}",
                  "isLoading": false,
                  "parentColumnSpace": 10.1513671875,
                  "parentRowSpace": 10,
                  "leftColumn": 63,
                  "rightColumn": 91,
                  "topRow": 5,
                  "bottomRow": 8,
                  "mobileLeftColumn": 32,
                  "mobileRightColumn": 60,
                  "mobileTopRow": 11,
                  "mobileBottomRow": 14,
                  "parentId": "fjg5c81ngj",
                  "dynamicBindingPathList": [
                    {
                      "key": "accentColor"
                    },
                    {
                      "key": "borderRadius"
                    },
                    {
                      "key": "boxShadow"
                    },
                    {
                      "key": "it_color"
                    },
                    {
                      "key": "it_size"
                    },
                    {
                      "key": "it_style"
                    },
                    {
                      "key": "labelTextColor"
                    },
                    {
                      "key": "labelTextSize"
                    },
                    {
                      "key": "labelStyle"
                    },
                    {
                      "key": "ib_bgColor"
                    },
                    {
                      "key": "ib_borderColor"
                    }
                  ],
                  "dynamicTriggerPathList": [],
                  "label": "选项",
                },
                {
                  "isVisible": true,
                  "label": "邮箱",
                  "labelPosition": "Left",
                  "labelAlignment": "right",
                  "labelWidth": 8,
                  "widgetName": "emailSearch",
                  "version": 2,
                  "iconAlign": "left",
                  "autoFocus": false,
                  "resetOnSubmit": true,
                  "isRequired": false,
                  "isDisabled": false,
                  "readonly": false,
                  "animateLoading": true,
                  "responsiveBehavior": "fill",
                  "minWidth": 375,
                  "inputType": "EMAIL",
                  "showStepArrows": false,
                  "isCount": false,
                  "minDynamicHeight": 3,
                  "maxDynamicHeight": 9000,
                  "dynamicHeight": "AUTO_HEIGHT",
                  "searchTags": [
                    "form",
                    "text input",
                    "number",
                    "textarea"
                  ],
                  "type": "INPUT_WIDGET_V2",
                  "hideCard": false,
                  "isDeprecated": false,
                  "displayName": "email",
                  "key": "91FDE99728213770",
                  "iconSVG": "./static/media/icon.d0ce957b6c4640f8a7418ce846ee200e.svg",
                  "widgetId": "684E0C926929BC84",
                  "renderMode": "CANVAS",
                  "accentColor": "{{appsmith.theme.colors.primaryColor}}",
                  "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                  "boxShadow": "{{appsmith.theme.boxShadow.appBoxShadow}}",
                  "it_color": "{{appsmith.theme.form.inputText.fontColor}}",
                  "it_size": "{{appsmith.theme.form.inputText.fontSize}}",
                  "it_style": "{{appsmith.theme.form.inputText.fontStyle}}",
                  "labelTextColor": "{{appsmith.theme.form.label.fontColor}}",
                  "labelTextSize": "{{appsmith.theme.form.label.fontSize}}",
                  "labelStyle": "{{appsmith.theme.form.label.fontStyle}}",
                  "ib_bgColor": "{{appsmith.theme.form.inputBorder.bgColor}}",
                  "ib_borderColor": "{{appsmith.theme.form.inputBorder.bgBorderColor}}",
                  "isLoading": false,
                  "parentColumnSpace": 8.382568359375,
                  "parentRowSpace": 10,
                  "leftColumn": 93,
                  "rightColumn": 121,
                  "topRow": 5,
                  "bottomRow": 8,
                  "mobileLeftColumn": 3,
                  "mobileRightColumn": 31,
                  "mobileTopRow": 5,
                  "mobileBottomRow": 8,
                  "parentId": "fjg5c81ngj",
                  "dynamicBindingPathList": [
                    {
                      "key": "accentColor"
                    },
                    {
                      "key": "borderRadius"
                    },
                    {
                      "key": "boxShadow"
                    },
                    {
                      "key": "it_color"
                    },
                    {
                      "key": "it_size"
                    },
                    {
                      "key": "it_style"
                    },
                    {
                      "key": "labelTextColor"
                    },
                    {
                      "key": "labelTextSize"
                    },
                    {
                      "key": "labelStyle"
                    },
                    {
                      "key": "ib_bgColor"
                    },
                    {
                      "key": "ib_borderColor"
                    }
                  ],
                  "dynamicTriggerPathList": [],
                  "shouldAllowAutofill": true,
                  "labelText": "邮箱"
                },
                {
                  "isVisible": true,
                  "defaultImage": "https://assets.appsmith.com/widgets/default.png",
                  "imageShape": "RECTANGLE",
                  "maxZoomLevel": 1,
                  "enableRotation": false,
                  "enableDownload": false,
                  "objectFit": "cover",
                  "image": "",
                  "widgetName": "intSearch",
                  "version": 1,
                  "animateLoading": true,
                  "value": "100",
                  "showTime": false,
                  "placeholderText1": "请选择开始日期",
                  "placeholderText2": "请选择结束日期",
                  "labelText": "整数",
                  "labelPosition": "Left",
                  "labelAlignment": "right",
                  "labelWidth": 8,
                  "Min": 0,
                  "Max": 9999,
                  "step": 1,
                  "defaultValue": 100,
                  "readOnly": false,
                  "stringMode": false,
                  "minDynamicHeight": 3,
                  "maxDynamicHeight": 9000,
                  "dynamicHeight": "AUTO_HEIGHT",
                  "type": "INPUTNUMBER_WIDGET",
                  "hideCard": false,
                  "isDeprecated": false,
                  "displayName": "int",
                  "key": "D09D3A5FB21619FA",
                  "iconSVG": "./static/media/icon.7824b9f0c785293524b78ae91a727700.svg",
                  "widgetId": "7A0924E31BCCB042",
                  "renderMode": "CANVAS",
                  "accentColor": "{{appsmith.theme.colors.primaryColor}}",
                  "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                  "boxShadow": "{{appsmith.theme.boxShadow.appBoxShadow}}",
                  "it_color": "{{appsmith.theme.form.inputText.fontColor}}",
                  "it_size": "{{appsmith.theme.form.inputText.fontSize}}",
                  "it_style": "{{appsmith.theme.form.inputText.fontStyle}}",
                  "labelTextColor": "{{appsmith.theme.form.label.fontColor}}",
                  "labelTextSize": "{{appsmith.theme.form.label.fontSize}}",
                  "labelStyle": "{{appsmith.theme.form.label.fontStyle}}",
                  "ib_bgColor": "{{appsmith.theme.form.inputBorder.bgColor}}",
                  "ib_borderColor": "{{appsmith.theme.form.inputBorder.bgBorderColor}}",
                  "isLoading": false,
                  "parentColumnSpace": 10.1513671875,
                  "parentRowSpace": 10,
                  "leftColumn": 3,
                  "rightColumn": 31,
                  "topRow": 9,
                  "bottomRow": 12,
                  "mobileLeftColumn": 62,
                  "mobileRightColumn": 90,
                  "mobileTopRow": 6,
                  "mobileBottomRow": 9,
                  "parentId": "fjg5c81ngj",
                  "dynamicBindingPathList": [
                    {
                      "key": "accentColor"
                    },
                    {
                      "key": "borderRadius"
                    },
                    {
                      "key": "boxShadow"
                    },
                    {
                      "key": "it_color"
                    },
                    {
                      "key": "it_size"
                    },
                    {
                      "key": "it_style"
                    },
                    {
                      "key": "labelTextColor"
                    },
                    {
                      "key": "labelTextSize"
                    },
                    {
                      "key": "labelStyle"
                    },
                    {
                      "key": "ib_bgColor"
                    },
                    {
                      "key": "ib_borderColor"
                    }
                  ],
                  "dynamicTriggerPathList": [],
                  "label": "整数"
                },
                {
                  "isVisible": true,
                  "label": "单行文本",
                  "labelPosition": "Left",
                  "labelAlignment": "right",
                  "labelWidth": 8,
                  "widgetName": "lineTextSearch",
                  "version": 2,
                  "iconAlign": "left",
                  "autoFocus": false,
                  "resetOnSubmit": true,
                  "isRequired": false,
                  "isDisabled": false,
                  "readonly": false,
                  "animateLoading": true,
                  "responsiveBehavior": "fill",
                  "minWidth": 375,
                  "inputType": "TEXT",
                  "showStepArrows": false,
                  "isCount": false,
                  "minDynamicHeight": 3,
                  "maxDynamicHeight": 9000,
                  "dynamicHeight": "AUTO_HEIGHT",
                  "searchTags": [
                    "form",
                    "text input",
                    "number",
                    "textarea"
                  ],
                  "type": "INPUT_WIDGET_V2",
                  "hideCard": false,
                  "isDeprecated": false,
                  "displayName": "lineText",
                  "key": "A874838E9F6F0C47",
                  "iconSVG": "./static/media/icon.d0ce957b6c4640f8a7418ce846ee200e.svg",
                  "widgetId": "8D5FCDC380307B42",
                  "renderMode": "CANVAS",
                  "accentColor": "{{appsmith.theme.colors.primaryColor}}",
                  "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                  "boxShadow": "{{appsmith.theme.boxShadow.appBoxShadow}}",
                  "it_color": "{{appsmith.theme.form.inputText.fontColor}}",
                  "it_size": "{{appsmith.theme.form.inputText.fontSize}}",
                  "it_style": "{{appsmith.theme.form.inputText.fontStyle}}",
                  "labelTextColor": "{{appsmith.theme.form.label.fontColor}}",
                  "labelTextSize": "{{appsmith.theme.form.label.fontSize}}",
                  "labelStyle": "{{appsmith.theme.form.label.fontStyle}}",
                  "ib_bgColor": "{{appsmith.theme.form.inputBorder.bgColor}}",
                  "ib_borderColor": "{{appsmith.theme.form.inputBorder.bgBorderColor}}",
                  "isLoading": false,
                  "parentColumnSpace": 8.382568359375,
                  "parentRowSpace": 10,
                  "leftColumn": 33,
                  "rightColumn": 61,
                  "topRow": 9,
                  "bottomRow": 12,
                  "mobileLeftColumn": 3,
                  "mobileRightColumn": 31,
                  "mobileTopRow": 5,
                  "mobileBottomRow": 8,
                  "parentId": "fjg5c81ngj",
                  "dynamicBindingPathList": [
                    {
                      "key": "accentColor"
                    },
                    {
                      "key": "borderRadius"
                    },
                    {
                      "key": "boxShadow"
                    },
                    {
                      "key": "it_color"
                    },
                    {
                      "key": "it_size"
                    },
                    {
                      "key": "it_style"
                    },
                    {
                      "key": "labelTextColor"
                    },
                    {
                      "key": "labelTextSize"
                    },
                    {
                      "key": "labelStyle"
                    },
                    {
                      "key": "ib_bgColor"
                    },
                    {
                      "key": "ib_borderColor"
                    }
                  ],
                  "dynamicTriggerPathList": [],
                  "labelText": "单行文本"
                },
                {
                  "isVisible": true,
                  "defaultImage": "https://assets.appsmith.com/widgets/default.png",
                  "imageShape": "RECTANGLE",
                  "maxZoomLevel": 1,
                  "enableRotation": false,
                  "enableDownload": false,
                  "objectFit": "cover",
                  "image": "",
                  "widgetName": "longIntSearch",
                  "version": 1,
                  "animateLoading": true,
                  "value": "100",
                  "showTime": false,
                  "placeholderText1": "请选择开始日期",
                  "placeholderText2": "请选择结束日期",
                  "labelText": "长整数",
                  "labelPosition": "Left",
                  "labelAlignment": "right",
                  "labelWidth": 8,
                  "Min": 0,
                  "Max": 9999,
                  "step": 1,
                  "defaultValue": 100,
                  "readOnly": false,
                  "stringMode": false,
                  "minDynamicHeight": 3,
                  "maxDynamicHeight": 9000,
                  "dynamicHeight": "AUTO_HEIGHT",
                  "type": "INPUTNUMBER_WIDGET",
                  "hideCard": false,
                  "isDeprecated": false,
                  "displayName": "longInt",
                  "key": "3B4A0B5F6D7D80B5",
                  "iconSVG": "./static/media/icon.7824b9f0c785293524b78ae91a727700.svg",
                  "widgetId": "3A86E7A907C7AAAE",
                  "renderMode": "CANVAS",
                  "accentColor": "{{appsmith.theme.colors.primaryColor}}",
                  "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
                  "boxShadow": "{{appsmith.theme.boxShadow.appBoxShadow}}",
                  "it_color": "{{appsmith.theme.form.inputText.fontColor}}",
                  "it_size": "{{appsmith.theme.form.inputText.fontSize}}",
                  "it_style": "{{appsmith.theme.form.inputText.fontStyle}}",
                  "labelTextColor": "{{appsmith.theme.form.label.fontColor}}",
                  "labelTextSize": "{{appsmith.theme.form.label.fontSize}}",
                  "labelStyle": "{{appsmith.theme.form.label.fontStyle}}",
                  "ib_bgColor": "{{appsmith.theme.form.inputBorder.bgColor}}",
                  "ib_borderColor": "{{appsmith.theme.form.inputBorder.bgBorderColor}}",
                  "isLoading": false,
                  "parentColumnSpace": 10.1513671875,
                  "parentRowSpace": 10,
                  "leftColumn": 63,
                  "rightColumn": 91,
                  "topRow": 9,
                  "bottomRow": 12,
                  "mobileLeftColumn": 62,
                  "mobileRightColumn": 90,
                  "mobileTopRow": 6,
                  "mobileBottomRow": 9,
                  "parentId": "fjg5c81ngj",
                  "dynamicBindingPathList": [
                    {
                      "key": "accentColor"
                    },
                    {
                      "key": "borderRadius"
                    },
                    {
                      "key": "boxShadow"
                    },
                    {
                      "key": "it_color"
                    },
                    {
                      "key": "it_size"
                    },
                    {
                      "key": "it_style"
                    },
                    {
                      "key": "labelTextColor"
                    },
                    {
                      "key": "labelTextSize"
                    },
                    {
                      "key": "labelStyle"
                    },
                    {
                      "key": "ib_bgColor"
                    },
                    {
                      "key": "ib_borderColor"
                    }
                  ],
                  "dynamicTriggerPathList": [],
                  "label": "长整数"
                },
                {
                  "isVisible": true,
                  "animateLoading": true,
                  "text": "查询",
                  "buttonVariant": "PRIMARY",
                  "placement": "CENTER",
                  "widgetName": "SearchBtn",
                  "isDisabled": false,
                  "isDefaultClickDisabled": true,
                  "disabledWhenInvalid": true,
                  "resetFormOnClick": false,
                  "recaptchaType": "V3",
                  "version": 1,
                  "borderRadius": "0.375rem",
                  "responsiveBehavior": "hug",
                  "minWidth": 120,
                  "searchTags": [
                    "click",
                    "submit"
                  ],
                  "type": "BUTTON_WIDGET",
                  "hideCard": false,
                  "isDeprecated": false,
                  "displayName": "Button",
                  "key": "4eqf0o3540",
                  "iconSVG": "./static/media/icon.2075e59f4c855dc62f664870206244a0.svg",
                  "widgetId": "E11D5751D4EECEFA",
                  "renderMode": "CANVAS",
                  "buttonColor": "{{appsmith.theme.colors.primaryColor}}",
                  "boxShadow": "none",
                  "isLoading": false,
                  "leftColumn": 93,
                  "rightColumn": 99,
                  "topRow": 9,
                  "bottomRow": 12,
                  "mobileLeftColumn": 46,
                  "mobileRightColumn": 62,
                  "mobileTopRow": 33,
                  "mobileBottomRow": 37,
                  "parentId": "fjg5c81ngj",
                  "dynamicBindingPathList": [
                    {
                      "key": "buttonColor"
                    }
                  ],
                  "dynamicTriggerPathList": [],
                  "originalTopRow": 9,
                  "originalBottomRow": 13,
                  "onClick": {
                    "label": "触发事件",
                    "name": "onClick",
                    "status": "add",
                    "children": [
                      {
                        "name": "block",
                        "type": "block",
                        "uid": "534dfd03bff94dc2b3871e77e931bf13",
                        "children": [
                          {
                            "name": "action",
                            "type": "action",
                            "pid": "534dfd03bff94dc2b3871e77e931bf13",
                            "uid": "b85bd56a60844565b3769d2c24b4c567",
                            "actionConfig": {
                              "action": "linkage",
                              "actionId": 412744702667678,
                              "apiTarget": "E11D5751D4EECEFA",
                              "apiDescription": null,
                              "linkageId": "ph6z3iu55h",
                              "linkageEvent": "onLoad",
                              "modalName": null
                            },
                            "children": null
                          },
                          {
                            "name": "success",
                            "type": "success",
                            "pid": "534dfd03bff94dc2b3871e77e931bf13",
                            "uid": "c2e2b819e5b54c4caf769d128ccdddf7",
                            "actionConfig": null,
                            "children": null
                          },
                          {
                            "name": "fail",
                            "type": "fail",
                            "pid": "534dfd03bff94dc2b3871e77e931bf13",
                            "uid": "8158d840b8a04cb2afb09b74ae3d249a",
                            "actionConfig": null,
                            "children": null
                          }
                        ]
                      }
                    ]
                  },
                  "iconName": "Search",
                  "iconAlign": "left"
                },
                {
                  "isVisible": true,
                  "animateLoading": true,
                  "text": "重置",
                  "buttonVariant": "SECONDARY",
                  "placement": "CENTER",
                  "widgetName": "SearchResetBtn",
                  "isDisabled": false,
                  "isDefaultClickDisabled": true,
                  "disabledWhenInvalid": false,
                  "resetFormOnClick": true,
                  "recaptchaType": "V3",
                  "version": 1,
                  "borderRadius": "0.375rem",
                  "responsiveBehavior": "hug",
                  "minWidth": 120,
                  "searchTags": [
                    "click",
                    "submit"
                  ],
                  "type": "BUTTON_WIDGET",
                  "hideCard": false,
                  "isDeprecated": false,
                  "displayName": "Button",
                  "key": "4eqf0o3540",
                  "iconSVG": "./static/media/icon.2075e59f4c855dc62f664870206244a0.svg",
                  "widgetId": "E868070003EE3F07",
                  "renderMode": "CANVAS",
                  "buttonColor": "{{appsmith.theme.colors.primaryColor}}",
                  "boxShadow": "none",
                  "isLoading": false,
                  "leftColumn": 100,
                  "rightColumn": 106,
                  "topRow": 9,
                  "bottomRow": 12,
                  "mobileLeftColumn": 30,
                  "mobileRightColumn": 46,
                  "mobileTopRow": 33,
                  "mobileBottomRow": 37,
                  "parentId": "fjg5c81ngj",
                  "dynamicBindingPathList": [
                    {
                      "key": "buttonColor"
                    }
                  ],
                  "dynamicTriggerPathList": [],
                  "originalTopRow": 9,
                  "originalBottomRow": 13,
                  "iconName": "Refresh",
                  "iconAlign": "left"
                }
              ],
              "minHeight": 120,
              "widgetId": "fjg5c81ngj",
              "renderMode": "CANVAS",
              "isLoading": false,
              "parentColumnSpace": 1,
              "parentRowSpace": 1,
              "leftColumn": 0,
              "rightColumn": 681.25,
              "topRow": 0,
              "bottomRow": 140,
              "mobileLeftColumn": 0,
              "mobileRightColumn": 681.25,
              "mobileTopRow": 0,
              "mobileBottomRow": 120,
              "parentId": "xwww1nd686",
              "dynamicBindingPathList": []
            }
          ],
          "positioning": "fixed",
          "responsiveBehavior": "fill",
          "minWidth": 375,
          "minDynamicHeight": 10,
          "maxDynamicHeight": 9000,
          "dynamicHeight": "AUTO_HEIGHT",
          "shouldScrollContents": true,
          "searchTags": [
            "group"
          ],
          "type": "SEARCH_FORM_WIDGET",
          "hideCard": false,
          "isDeprecated": false,
          "displayName": "SearchForm",
          "key": "026kawdwv3",
          "iconSVG": "./static/media/icon.e53255f93b460413bbba61be56eb1978.svg",
          "isCanvas": true,
          "widgetId": "xwww1nd686",
          "renderMode": "CANVAS",
          "borderRadius": "{{appsmith.theme.borderRadius.appBorderRadius}}",
          "boxShadow": "{{appsmith.theme.boxShadow.appBoxShadow}}",
          "accentColor": "{{appsmith.theme.colors.primaryColor}}",
          "isLoading": false,
          "parentColumnSpace": 8.515625,
          "parentRowSpace": 10,
          "leftColumn": 1,
          "rightColumn": 127,
          "topRow": 1,
          "bottomRow": 15,
          "mobileLeftColumn": 1,
          "mobileRightColumn": 81,
          "mobileTopRow": 12,
          "mobileBottomRow": 24,
          "parentId": "0",
          "dynamicBindingPathList": [
            {
              "key": "borderRadius"
            },
            {
              "key": "boxShadow"
            },
            {
              "key": "accentColor"
            }
          ],
          "originalTopRow": 1,
          "originalBottomRow": 17,
          "dynamicTriggerPathList": []
        }
      ]
    }
}
